/**
 * Sunucu hatasını operatörün diline çeviren TEK yer.
 *
 * Kural: yalnızca `code` alanına dallanılır. Sunucunun `message` alanı dil
 * bağımsız değildir, çoğu hatada hiç yoktur ve 5xx'te bilerek boşaltılır —
 * bu yüzden bu modülün dışına çıkmaz.
 *
 * snak'ta bu kural yorumla korunuyordu ve çağrı noktalarında deliniyordu
 * (`adminErrorMessage(err, t, err.message)` gibi). Burada `fallback`
 * parametresi YOK: fonksiyon her zaman sözlükten bir cümle döndürür, dolayısıyla
 * ham sunucu metnini geçirmenin bir yolu da yoktur.
 */

const MESSAGES: Record<string, string> = {
  // ── Kimlik
  INVALID_CREDENTIALS: 'E-posta veya şifre hatalı.',
  ACCOUNT_DISABLED: 'Bu hesap devre dışı bırakılmış.',
  TWO_FACTOR_REQUIRED: 'İki adımlı doğrulama kodu gerekli.',
  INVALID_TWO_FACTOR_CODE: 'Doğrulama kodu geçersiz veya süresi dolmuş.',
  TWO_FACTOR_CODE_ALREADY_USED:
    'Bu kod zaten kullanıldı. Uygulamanızın ürettiği bir sonraki kodu bekleyin.',
  TWO_FACTOR_ALREADY_ENABLED: 'İki adımlı doğrulama zaten açık.',
  TWO_FACTOR_NOT_ENABLED: 'İki adımlı doğrulama açık değil.',
  TWO_FACTOR_NOT_INITIALIZED: 'Önce kurulum adımını tamamlayın.',
  TWO_FACTOR_ENCRYPTION_UNAVAILABLE:
    'Sunucuda şifreleme anahtarı tanımlı değil — iki adımlı doğrulama kurulamaz.',
  INVALID_REFRESH_TOKEN: 'Oturum yenilenemedi, lütfen tekrar giriş yapın.',
  TOKEN_REVOKED: 'Bu oturum sonlandırılmış. Lütfen tekrar giriş yapın.',
  TOKEN_STALE: 'Yetkileriniz değişti. Lütfen tekrar giriş yapın.',
  AUTH_REQUIRED: 'Oturum açmanız gerekiyor.',
  AUTH_EXPIRED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',

  // ── Komut satırı anahtarları (cm)
  API_TOKEN_EXPIRY_INVALID: 'Geçerlilik 1 ile 366 gün arasında olmalı.',
  API_TOKEN_NOT_FOUND: 'Anahtar bulunamadı.',
  API_TOKEN_MANAGEMENT_REQUIRES_SESSION:
    'Anahtarlar yalnız panel oturumuyla yönetilir; bir anahtar başka bir anahtarı oluşturamaz veya iptal edemez.',
  API_TOKEN_NOT_ACCEPTED_HERE:
    'Komut satırı anahtarı bu adreste geçmez; yalnız sunucu içi kapıda (CLI_PORT) kabul edilir.',
  API_TOKEN_INVALID: 'Anahtar geçersiz ya da iptal edilmiş.',
  API_TOKEN_EXPIRED: 'Anahtarın süresi dolmuş. Panelde yenisini oluşturun.',
  API_TOKEN_READ_ONLY: 'Bu anahtar salt okumadır; kayıt ekleyemez, değiştiremez, silemez.',

  // ── Yetki
  FORBIDDEN: 'Bu işlem için yetkiniz yok.',
  FORBIDDEN_ROLE: 'Bu işlem için rolünüz yetersiz.',
  FORBIDDEN_AREA: 'Bu bölüme erişim yetkiniz yok.',
  READ_ONLY_ROLE: 'Salt okuma yetkisiyle değişiklik yapılamaz.',

  // ── Doğrulama
  VALIDATION_ERROR: 'Formda geçersiz alanlar var.',
  INVALID_EMAIL: 'E-posta adresi geçersiz.',
  EMAIL_TAKEN: 'Bu e-posta adresi zaten kayıtlı.',
  UNKNOWN_PERMISSION_AREA: 'Tanınmayan yetki alanı seçildi.',
  USER_NOT_FOUND: 'Kullanıcı bulunamadı.',
  CANNOT_CHANGE_OWN_ROLE: 'Kendi rolünüzü değiştiremezsiniz.',
  CANNOT_DISABLE_SELF: 'Kendi hesabınızı devre dışı bırakamazsınız.',
  LAST_ADMIN: 'Sistemde en az bir aktif yönetici kalmalı.',

  // ── Ayarlar
  UNKNOWN_SETTING_KEY: 'Tanınmayan bir ayar anahtarı gönderildi.',
  ADMIN_ONLY_SETTING: 'Bu ayarı yalnızca yönetici değiştirebilir.',
  INVALID_SETTING_VALUE: 'Ayar değeri beklenen türe uymuyor.',
  SETTINGS_ENCRYPTION_UNAVAILABLE:
    'Sunucuda şifreleme anahtarı tanımlı değil — gizli ayar kaydedilemez.',

  // ── Belçika iş kuralları (hukuki dayanağı olan hatalar)
  INVALID_ENTERPRISE_NUMBER: 'İşletme numarası geçersiz (10 hane, mod-97 sağlaması tutmuyor).',
  INVALID_VAT_NUMBER: 'KDV numarası geçersiz (mod-97 sağlaması tutmuyor).',
  IBAN_MUST_BE_BELGIAN:
    'IBAN Belçika hesabı olmalı (BE…). Ödeme talep eden belgede yabancı IBAN yasal olarak yetmez — WER md. III.25 §2.',
  INVALID_IBAN: 'IBAN sağlaması tutmuyor.',
  INVALID_DATE: 'Tarih YYYY-AA-GG biçiminde olmalı.',
  INVALID_BIC: 'BIC geçersiz — 8 ya da 11 karakter olmalı.',

  // ── Cariler
  CONTACT_NOT_FOUND: 'Cari bulunamadı; başka bir oturumda silinmiş olabilir.',
  CONTACT_HAS_DOCUMENTS:
    'Bu cariye ait belge var; silinemez. Mali bir belgenin gösterdiği karşı taraf kaybolamaz — cariyi PASİFLEŞTİRİN, geçmiş faturalar olduğu gibi kalır.',
  CONTACT_MUST_HAVE_ROLE: 'Cari en az müşteri ya da tedarikçi olmalı.',
  CONTACT_VAT_NUMBER_TAKEN: 'Bu KDV numarası başka bir caride kayıtlı.',
  CONTACT_INVALID_DATA: 'Veritabanı kuralı ihlal edildi; alanların bileşimi geçerli değil.',
  CONTACT_NOT_CUSTOMER:
    'Bu cari müşteri olarak işaretli değil. Cari detayından "müşteri" kutusunu işaretleyin.',

  // ── Katalog
  ITEM_NOT_FOUND: 'Kalem bulunamadı; katalogdan silinmiş olabilir.',
  ITEM_CODE_TAKEN: 'Bu kod başka bir kalemde kullanılıyor. Kodlar benzersizdir.',
  ITEM_IN_USE:
    'Bu kalem bir faturada kullanılmış; silinemez. Mali bir belgenin gösterdiği satır kaybolamaz — kalemi pasifleştirin, geçmiş faturalar olduğu gibi kalır.',
  ITEM_ESS_REQUIRES_SERVICE:
    '"Elektronik hizmet" yalnız HİZMET kaleminde işaretlenebilir: Reg. 282/2011 md. 7 bir hizmet testidir, "elektronik olarak sunulan mal" diye bir kategori yoktur.',
  ITEM_IMMOVABLE_REQUIRES_SERVICE:
    '"Taşınmaz üzerinde iş" yalnız HİZMET kaleminde işaretlenebilir: WBTW md. 19 §2 taşınmaza ilişkin İŞTİR, mal teslimine yurtiçi ters yükümlülük uygulanmaz.',
  ITEM_SOLD_REQUIRES_GOODS:
    '"Satıldı" yalnız MAL kaleminde seçilebilir: mülkiyet devrediliyorsa teslim mal teslimidir (Dir. 2006/112 md. 14(1) / WBTW md. 10). Kiosk+abonelik gibi BİLEŞİK bir edimin hangi tarafa düştüğü ayrı bir sorudur (CJEU CPP C-349/96, Levob C-41/04). Bu bileşim AB B2B\'de kutu 46 yerine 44\'e düşerdi.',
  ITEM_INVALID_TEXT: 'Ad/açıklama eksik ya da geçersiz: Fransızca metin zorunludur.',
  ITEM_INVALID_AMOUNT: 'Tutar geçersiz. Nokta ile ve en fazla iki ondalıkla yazın (örn. 1234.56).',
  ITEM_INVALID_VAT_RATE: 'KDV oranı geçersiz. 0 ile 100 arasında olmalı.',
  ITEM_INVALID_DATA: 'Veritabanı kuralı ihlal edildi; alanların bileşimi geçerli değil.',
  HARDWARE_SUPPLY_DISABLED:
    'Donanım tedariki şirket ayarlarında KAPALI: mal teslimi, donanım kiralaması ve taşınmaza montaj bugün faturalanmıyor. Gerçekten donanım tedarik ediyorsanız bir yönetici Ayarlar → Vergi profili → "Kiosk / donanım tedariki"ni açmalı. Kiosk taşınmaza sabitlenecekse önce ruling alın (WBTW md. 19 §2).',

  // ── Satış belgeleri
  INVOICE_NOT_FOUND: 'Belge bulunamadı; başka bir oturumda silinmiş olabilir.',
  INVOICE_NO_LINES:
    'Satırsız belge, KB nr. 1 md. 5 §1, 6°’nın istediği "teslim edilen mal veya hizmetin tanımı"nı taşıyamaz. En az bir satır ekleyin.',
  INVOICE_NOT_DRAFT:
    'Bu belge artık taslak değil. Düzenlenmiş belge DEĞİŞMEZ; düzeltmenin tek hukuki yolu kredi notudur (KB nr. 1 md. 12).',
  INVOICE_IMMUTABLE:
    'Düzenlenmiş belge DEĞİŞMEZ — veritabanı tetikleyicisi değişikliği reddetti. Düzeltmenin tek hukuki yolu kredi notudur (KB nr. 1 md. 12).',
  INVOICE_CANCEL_REQUIRES_CREDIT_NOTE:
    'Düzenlenmiş bir belge hukuken iptal EDİLEMEZ (KB nr. 1 md. 12). İptal yerine kredi notu kesin.',
  INVOICE_MODIFIED_DURING_ISSUE:
    'Belge siz düzenlemeye çalışırken başka bir yerde değişti. Sayfayı tazeleyip yeniden deneyin — eski satırlarla dondurulmuş bir belge, ancak kredi notuyla düzeltilebilirdi.',
  INVOICE_MIXED_VAT_TREATMENT:
    'Bir belgede tek KDV muamelesi olabilir; zorunlu ibare ve kutu eşleme BELGE seviyesindedir. Doğru çözüm iki ayrı faturadır.',
  INVOICE_VAT_BLOCKED:
    'Çözümleyici bu belgeyi düzenlemeyi engelledi. Bloke edicilerin tamamı aşağıda.',
  INVOICE_DUE_BEFORE_ISSUE: 'Vade tarihi, düzenleme tarihinden önce olamaz.',
  /*
   * M16 — ön tahsilat (BT-113: fatura kesilmeden önce alınmış kısım, ör.
   * Stripe'ın ay içinde kestiği komisyon) ve dış kaynak kimliği.
   */
  INVOICE_PREPAID_NOT_ALLOWED:
    'Önceden tahsil edilmiş tutar yalnız faturada yazılabilir; kredi notu ödeme talep etmez, proforma fatura değildir.',
  INVOICE_PREPAID_AMOUNT_INVALID:
    'Önceden tahsil edilen tutar sıfırdan büyük ve en çok iki ondalıklı olmalı (ör. 12.50).',
  INVOICE_PREPAID_DATES_INVALID:
    'Ön tahsilatın ilk ve son günü YYYY-AA-GG biçiminde olmalı ve ilk gün son günden sonra olamaz.',
  INVOICE_PREPAID_AFTER_ISSUE:
    'Fatura tarihinden SONRA gelen para ön tahsilat değil tahsilattır: belgeyi kestikten sonra "Tahsilat ekle" ile kaydedin.',
  INVOICE_PREPAID_NOTE_REQUIRED:
    'Ön tahsilatın ne olduğunu belgenin dilinde kısaca yazın (en çok 200 karakter); bu cümle faturaya basılır.',
  INVOICE_PREPAID_EXCEEDS_TOTAL:
    'Önceden tahsil edilen tutar fatura toplamını aşıyor; ödenecek tutar eksiye düşerdi. Tutarı ya da satırları kontrol edin.',
  INVOICE_SOURCE_REF_INVALID: 'Dış kaynak kimliği boş olamaz ve 120 karakteri aşamaz.',
  INVOICE_SOURCE_DUPLICATE:
    'Bu dış kaynak kaydı (ör. aynı restoran-ay) için iptal edilmemiş bir belge zaten var; ikinci kez faturalanmaz.',
  /*
   * ── M17 snak entegrasyonu ─────────────────────────────────────────────
   * Bekleme sebepleri (ekstre geldi, fatura KESİLMEDİ) ve yönetim redleri.
   * Sebep giderilince ekstre her sabah kendiliğinden yeniden denenir; panelde
   * "Yeniden dene" de aynı yoldur.
   */
  SNAK_NO_SYSTEM_ACTOR:
    'Fatura kesildi ama gönderilmedi: gönderim kaydını üstlenecek aktif bir yönetici hesabı yok. Bir yönetici hesabını etkinleştirin; gönderim ertesi sabah yeniden denenir.',
  SNAK_TENANT_DISABLED:
    'Bu restoranın entegrasyonu kapatılmış; fatura kesilmedi. Sözleşme sürüyorsa restoranı yeniden açın, bitmişse ekstreyi bekletilmiş bırakın.',
  SNAK_CONTACT_MISSING: 'Restorana bağlı cari bulunamadı. Restoran ayarlarında doğru cariyi seçin.',
  SNAK_CONTACT_INVALID:
    'Seçilen kayıt bir müşteri carisi değil (ya da yok). Müşteri olarak işaretli bir cari seçin.',
  SNAK_RESTAURANT_MISMATCH:
    'snak sunucusunun bildirdiği KDV numarası bağlı carininkiyle TUTMUYOR. Yanlış anahtarla kurulmuş bir sunucu başka bir restoranın faturasını kestirirdi: önce snak sunucusunun anahtarını ve carinin KDV numarasını kontrol edin.',
  SNAK_NO_TERMS:
    'Bu ayın ilk günü yürürlükte olan bir sözleşme koşulu yok. Restorana o aydan geçerli bir koşul (ücret, komisyon) ekleyin.',
  SNAK_BILLING_MODE_MISMATCH:
    'snak sunucusundaki faturalama modu sözleşmedekinden farklı. Restoran sahibi snak ayarını değiştirmiş olabilir: ya snak ayarını düzeltin ya da yeni bir sözleşme koşulu ekleyin.',
  SNAK_FEE_MISMATCH:
    'snak sunucusunun bildirdiği aylık ücret sözleşmedekinden farklı. Fatura sözleşmedeki ücretle kesilir; fark çözülene kadar beklenir (snak ayarı ya da sözleşme koşulu düzeltilmeli).',
  SNAK_UNEXPECTED_COMMISSION:
    'Sözleşme yalnız sabit ücret öngörüyor ama snak komisyon bildirdi. snak faturalama modunu ya da sözleşme koşulunu düzeltin.',
  SNAK_PAYLOAD_INCONSISTENT_COMMISSION:
    'snak ekstresi kendi içinde çelişkili: sipariş yok ama komisyon var. snak tarafındaki kapanış kontrol edilmeli.',
  SNAK_COMMISSION_PERCENT_MISMATCH:
    'snak sunucusundaki komisyon oranı sözleşmedekinden farklı. snak ayarını ya da sözleşme koşulunu düzeltin.',
  SNAK_VAT_MODE_MISMATCH:
    'Komisyonun KDV kipi (hariç/dahil) snak ile sözleşme arasında farklı. snak ayarını ya da sözleşme koşulunu düzeltin.',
  SNAK_COMMISSION_ARITHMETIC_MISMATCH:
    'Bildirilen komisyon tutarı "taban × oran"dan yuvarlama payının ötesinde farklı. snak ekstresi incelenmeli; fatura kesilmedi.',
  SNAK_ITEM_NOT_CONFIGURED:
    'Restoranın ücret ya da komisyon kalemi seçilmemiş. Restoran ayarlarında katalogdan kalemleri seçin.',
  SNAK_NO_DELIVERY_CHANNEL:
    'Fatura müşteriye iletilemezdi: carinin e-fatura e-posta rızası kayıtlı değil (Peppol henüz bağlı değil). Carinin e-fatura e-posta adresini ve rıza tarihini girin.',
  SNAK_TOTAL_MISMATCH:
    'Faturanın toplamı snak ekstresindeki brüt tutarla tutmuyor; restoranın gördüğü ile fatura ayrışacağı için kesilmedi. Taslak faturayı ve ekstreyi karşılaştırın.',
  SNAK_STATEMENT_NOT_FOUND: 'Ekstre bulunamadı.',
  SNAK_TENANT_NOT_FOUND: 'Restoran kaydı bulunamadı.',
  SNAK_STATEMENT_BUSY: 'Bu ekstre şu anda değerlendiriliyor. Birkaç saniye sonra yeniden deneyin.',
  SNAK_TENANT_HAS_STATEMENTS:
    'Bu restoran ekstre almış; kayıt faturalama izinin parçası olduğu için silinemez. Kullanılmayacaksa Düzenle → Durum: Kapalı yapın.',
  SNAK_FEE_BILLING_LOCKED:
    'Bu restoranın faturası kesilmiş bir ayı var; peşin/sonradan seçimi artık değiştirilemez. Değişiklik bir ayı ya iki kez ya da hiç faturalardı.',
  SNAK_TERMS_LIST_PRICE_INVALID:
    'Liste fiyatı yalnız aylık ücreti olan bir koşulda ve ücretten DÜŞÜK olmadan girilebilir (fark faturada indirim olarak görünür).',
  SNAK_TENANT_KEY_TAKEN: 'Bu restoran anahtarı başka bir kayıtta kullanılıyor.',
  SNAK_TERMS_NOT_MONTH_START: 'Sözleşme koşulu bir ayın İLK günü başlamalı (YYYY-AA-01).',
  SNAK_TERMS_PERIOD_ALREADY_INVOICED:
    'Bu tarihten sonraki bir ayın faturası zaten kesilmiş; o ayı geriye dönük değiştiren bir koşul eklenemez. Koşulu faturalanmamış ilk aydan başlatın; geçmiş ayın düzeltmesi kredi notu ya da ek faturayla yapılır.',
  SNAK_TERMS_DUPLICATE_MONTH: 'Bu restoran için aynı aydan başlayan bir koşul zaten var.',
  SNAK_TERMS_INCONSISTENT:
    'Mod ile tutarlar uyuşmuyor: "sabit" modda komisyon 0 olmalı, "komisyon" modunda ücret 0 olmalı, "karma" modda ikisi de dolu; oran en çok %30.',
  SNAK_PAYLOAD_NOT_JSON: 'Saklanan snak ekstresi okunamadı (JSON değil).',
  SNAK_PAYLOAD_VERSION_UNSUPPORTED: 'snak ekstresinin sürümü bu muhasebe sürümünce tanınmıyor.',
  SNAK_PAYLOAD_UNKNOWN_FIELD:
    'snak ekstresinde tanınmayan bir alan var; ekstre bilerek reddedildi.',
  SNAK_PAYLOAD_AMOUNT_INVALID: 'snak ekstresinde geçersiz bir tutar var.',
  SNAK_PAYLOAD_DATE_INVALID: 'snak ekstresinde geçersiz bir tarih var.',
  SNAK_PAYLOAD_FIELD_INVALID: 'snak ekstresinde geçersiz bir alan var.',
  SNAK_PAYLOAD_PERIOD_INVALID: 'snak ekstresinin dönemi bir takvim ayı değil.',
  SNAK_PAYLOAD_INCONSISTENT: 'snak ekstresinin tutarları kendi içinde tutmuyor (net + KDV ≠ brüt).',
  SNAK_PAYLOAD_EMPTY: 'snak ekstresinde faturalanacak bir tutar yok.',
  SNAK_PAYLOAD_VAT_RATE_UNSUPPORTED: 'snak ekstresindeki KDV oranı desteklenmiyor (yalnız %21).',
  INVOICE_VAT_PERIOD_PREPARED:
    'Bu belgenin KDV dönemi için beyan zaten HAZIRLANMIŞ. Belge eklenirse arşivdeki beyan dosyası yanlış olur: önce KDV beyanı ekranında hazırlanan kaydı silin, belgeyi düzenleyin, beyanı yeniden hazırlayın.',
  INVOICE_VAT_PERIOD_SUBMITTED:
    'Bu belgenin KDV dönemi için beyan zaten VERİLMİŞ (geç kesilen faturada KDV, hizmeti izleyen ayın 15inin dönemine düşer). Belge sessizce o döneme yazılmadı. Verilmiş döneme ait KDV sonraki beyanda düzeltilir; bu yol henüz otomatik değil.',
  INVOICE_DATE_INVALID: 'Tarih YYYY-AA-GG biçiminde ve gerçek bir takvim günü olmalı.',
  INVOICE_ISSUE_DATE_INVALID: 'Düzenleme tarihi geçersiz.',
  INVOICE_LINE_ITEM_REQUIRED:
    'Her satır bir katalog kalemine bağlı olmak zorunda: serbest metin satırında KDV nitelendirmesi bilinmez ve belge sessizce yurtiçi dala düşer.',
  INVOICE_LINE_ITEM_NOT_FOUND: 'Satırdaki kalem bulunamadı; katalogdan silinmiş olabilir.',
  INVOICE_LINE_MISMATCH: 'Satırlar düzenleme sırasında değişti. Sayfayı tazeleyip yeniden deneyin.',
  INVOICE_TOTALS_AMOUNT_OUT_OF_RANGE:
    'Toplam, `decimal(14,2)` kolonunun taşıyabileceği aralığın dışında. Adet ya da birim fiyatı kontrol edin.',
  /*
   * ⚠ BU ON ALTI KOD `invoice-totals.ts`ten gelir ve HEPSİ sözlükte yoktu.
   * Sebep ölçüldü: sürüklenme kapısı o dosyayı TARAMIYORDU, çünkü kodlar
   * `throw new InvoiceTotalsError('…')` biçiminde yazılıyor ve dosya tarama
   * listesinde değildi. Kanıt kapının sınırında duruyor: aynı dosyanın
   * kodlarından yalnız `…AMOUNT_OUT_OF_RANGE` sözlükteydi — çünkü o TEK kod
   * taranan `sales-invoice.service.ts` içinden atılıyor.
   *
   * Hepsi panele ÜST DÜZEY `code` olarak ulaşıyor (`safeTotals` onları
   * `BadRequestException({ code })`e çeviriyor), yani açıklaması olmayan kod
   * operatöre "Sunucuda beklenmeyen bir hata" diye görünüyordu — oysa arıza
   * neredeyse her zaman girilen bir sayıdır.
   */
  INVOICE_TOTALS_NO_LINES: 'Belgede hiç satır yok; boş bir belge düzenlenemez.',
  INVOICE_TOTALS_LINE_NO_INVALID: 'Satır numarası 1 ya da daha büyük bir tam sayı olmalı.',
  INVOICE_TOTALS_DUPLICATE_LINE_NO:
    'Aynı satır numarası iki kez kullanılmış. Sayfayı tazeleyip yeniden deneyin.',
  INVOICE_TOTALS_QUANTITY_INVALID:
    'Adet okunamadı. Ondalık ayracı NOKTA olmalı (`1.5`); virgüllü yazım (`1,5`) kabul edilmiyor.',
  INVOICE_TOTALS_QUANTITY_NOT_POSITIVE:
    'Adet sıfırdan büyük olmalı. Sıfır adetli satır belgede yer kaplar, hiçbir şey ifade etmez.',
  INVOICE_TOTALS_NEGATIVE_UNIT_PRICE:
    'Birim fiyat negatif olamaz. Tutarlar pozitif saklanır; işaret belge türünden gelir — iade için kredi notu kesilir.',
  INVOICE_TOTALS_DISCOUNT_PCT_OUT_OF_RANGE: 'İndirim yüzdesi %100’ü aşamaz.',
  INVOICE_TOTALS_VAT_RATE_OUT_OF_RANGE: 'KDV oranı %100’ü aşamaz.',
  INVOICE_TOTALS_NONZERO_RATE_FOR_CATEGORY:
    'Standart oran dışındaki bir KDV kategorisinde (ters yükümlülük, muafiyet, kapsam dışı) oran sıfır olmak zorunda. Oran yazılırsa beyanda hem matrah hem KDV doğar ve Peppol doğrulaması da düşer.',
  INVOICE_TOTALS_STANDARD_RATE_ZERO:
    'Standart oranlı satırın oranı sıfır olamaz (EN 16931 BR-S-08/09). Bedelsiz kalem için birim fiyatı 0 yazın, oranı bırakın.',
  INVOICE_TOTALS_NEGATIVE_LINE_DISCOUNT: 'Satır indirimi negatif olamaz.',
  INVOICE_TOTALS_LINE_DISCOUNT_EXCEEDS_LINE:
    'Satır indirimi, satırın kendi tutarını aşamaz — aksi hâlde satır negatife düşerdi.',
  INVOICE_TOTALS_NEGATIVE_DOCUMENT_DISCOUNT: 'Belge indirimi negatif olamaz.',
  INVOICE_TOTALS_DISCOUNT_EXCEEDS_NET:
    'Belge indirimi, satır toplamını aşamaz. İndirim satırlara oranlanarak dağıtılıyor ve hiçbir satırın matrahı negatife düşemez.',
  INVOICE_TOTALS_CATEGORY_O_MIXED:
    'Kapsam dışı (`O`) satır, başka bir KDV kategorisiyle aynı belgede bulunamaz (EN 16931 BR-O-11/12). Kapsam dışı kalemleri ayrı bir faturaya alın.',
  INVOICE_TOTALS_EXEMPTION_CONFLICT:
    'Aynı kategori ve oran grubundaki satırlara farklı muafiyet gerekçeleri yazılmış. Bir grup tek bir gerekçe taşır.',
  /*
   * ⚠ `document-counter.service.ts` de kapıda yoktu: on bir kodun dokuzu elle
   * eklenmişti, ikisi (aşağıdakiler) atlanmıştı.
   */
  INVOICE_IMPORT_SEQUENCE_INVALID:
    'Aktarılan belgenin numara sırası geçersiz: 1 ya da daha büyük bir tam sayı olmalı.',
  /*
   * ⚠ BU BİR 5xx VE OPERATÖR HATASI DEĞİL. Sayaç satırı okunamadığında kod
   * bilerek patlıyor: sessizce 1 döndürmek, İLK FATURANIN numarasını ikinci
   * kez vermek olurdu. Metin bu yüzden "yeniden deneyin" demiyor.
   */
  DOCUMENT_COUNTER_NO_ROW:
    'Belge numarası sayacı okunamadı ve yazılım bilerek durdu — sessizce bir numara uydurmak, aynı numaranın ikinci kez verilmesi riskini taşır. Hiçbir numara yakılmadı; durum sürerse veritabanı günlüklerine bakılmalı.',
  INVOICE_VAT_GRID_MISSING:
    'Bu muamele için Intervat kutusu türetilemedi. Belge düzenlenirse beyanda matrahı hiçbir kutuya yazılamazdı.',
  INVOICE_NUMBER_CONFLICT:
    'Numara çakıştı — aynı anda başka bir belge düzenlenmiş olabilir. Yeniden deneyin.',
  INVOICE_NUMBER_TOO_LONG:
    'Numara biçimi 64 karakteri aşan bir numara üretiyor. Ayarları düzeltin.',
  INVOICE_NUMBER_FORMAT_MISSING_SEQ:
    'Numara biçiminde sıra alanı yok; sayaç olmadan kesintisiz dizi kurulamaz.',
  INVOICE_NUMBER_FORMAT_MISSING_YEAR: 'Numara biçiminde yıl alanı yok.',
  INVOICE_NUMBER_FORMAT_MISSING_SERIES: 'Numara biçiminde seri alanı yok.',
  INVOICE_NUMBER_FORMAT_BAD_SEQ_WIDTH: 'Numara biçimindeki sıra genişliği geçersiz.',
  INVOICE_NUMBER_FORMAT_UNKNOWN_TOKEN: 'Numara biçiminde tanınmayan bir alan var.',
  INVOICE_SERIES_INVALID: 'Belge serisi ayarı geçersiz.',
  INVOICE_INVALID_DATA: 'Veritabanı kuralı ihlal edildi; alanların bileşimi geçerli değil.',
  INVOICE_LANGUAGE_UNRESOLVED:
    'Belgenin yasal dili çözülemedi: Ayarlarda işletme merkezinin bölgesi seçilmemiş (Taaldecreet 19.07.1973).',
  INVOICE_MISSING_BELGIAN_IBAN:
    'Ödeme talep eden belgede BE ile başlayan bir IBAN zorunlu (WER md. III.25 §2). Ayarlardaki IBAN alanını doldurun.',
  INVOICE_MISSING_ENTERPRISE_NUMBER:
    'Geçerli bir KBO/BCE işletme numarası zorunlu (WER md. III.25 §1). Ayarlardan girin.',
  INVOICE_MISSING_SELLER_VAT_NUMBER:
    'Satıcının KDV kimlik numarası zorunlu (KB nr. 1 md. 5 §1). Ayarlardaki KDV numarası alanını doldurun.',
  INVOICE_MISSING_SELLER_ADDRESS:
    'İşletmenin adresi eksik (KB nr. 1 md. 5 §1 tarafların adını VE adresini ister). Ayarlarda adres, posta kodu ve şehir alanlarını doldurun.',
  INVALID_PEPPOL_PARTICIPANT_ID:
    'Peppol katılımcı kimliği "<4 haneli şema>:<değer>" biçiminde olmalı (örn. 0208:1041328256). ' +
    '0208 şemasında değer, sağlaması tutan ayraçsız 10 haneli bir işletme numarasıdır — nokta ' +
    've boşluk kabul edilmez.',
  INVOICE_MISSING_BUYER_ADDRESS:
    'Müşterinin adresi eksik (KB nr. 1 md. 5 §1). Cari detayından adres, posta kodu ve şehir alanlarını doldurun.',
  INVOICE_BUYER_VAT_NUMBER_INVALID:
    'Belçikalı müşterinin KDV numarası sağlama basamağını geçmiyor (mod-97): son iki hane ' +
    'numaranın geri kalanından hesaplanır ve tutmuyor — bir hane şaşmış olabilir. Cari ' +
    'detayından düzeltin. ⚠ Numara belgeye DONAR ve e-faturaya BT-48 olarak gider; bozuk ' +
    'dondurulursa düzeltmenin tek yolu kredi notudur.',
  INVOICE_MISSING_BUYER_VAT_NUMBER:
    'Bu KDV muamelesi (ters yükümlülük / AB içi teslim) alıcının KDV numarasını ZORUNLU kılar (EN 16931 BR-AE-03 / BR-IC-03). Cari detayından KDV numarasını girin — belge düzenlendikten sonra eklenemez.',
  INVOICE_CUSTOMER_TYPE_UNRESOLVED:
    'Bu carinin KDV numarası var ama müşteri tipi seçilmemiş. KDV numarası taşıyan bir cari tüketici sayılamaz ve tip, belgenin Peppol’den geçmek zorunda olup olmadığını belirler. Cari detayından müşteri tipini seçin.',
  INVOICE_SELLER_ADDRESS_TOO_LONG:
    'İşletme adresi belgenin taşıyabileceğinden uzun. Kırpmak, PDF ile e-faturanın farklı adres göstermesi demek olurdu — Ayarlardaki adres alanlarını kısaltın.',
  INVOICE_PEPPOL_PARTICIPANT_REQUIRED:
    'Bu müşterinin Peppol katılımcı kimliği yok. Kimlik işletme numarasından türetilir; cari detayından işletme numarasını (ya da doğrudan Peppol kimliğini) girin. ⚠ Adres belgeye DONAR: boş dondurulursa fatura bir daha gönderilemez.',
  INVOICE_PEPPOL_PARTICIPANT_INVALID:
    'Müşterinin Peppol katılımcı kimliği geçersiz. 0208 şeması ayraçsız 10 haneli işletme ' +
    'numarası ister ve son iki hane bir sağlama basamağıdır — bir hane şaşmış olabilir. Cari ' +
    'detayından düzeltin. ⚠ Kimlik belgeye DONAR: bozuk dondurulursa fatura bir daha ' +
    'gönderilemez ve tek çıkış kredi notudur.',
  INVOICE_PEPPOL_REFERENCE_REQUIRED:
    'Yurtiçi B2B faturası Peppol’den geçmek zorunda (md. 53 §2bis) ve Peppol, alıcı referansı (BT-10) ya da sipariş referansı (BT-13) taşımayan belgeyi REDDEDER. En az birini doldurun — belge düzenlendikten sonra eklenemez.',

  // ── M3 alış faturaları
  /*
   * ⚠ BU BLOK EKLENİRKEN KAPI DA GENİŞLETİLDİ. `invoices-api.spec.ts`
   * yalnız satış servisini ve UBL eşleyicisini tarıyordu; alış servisi
   * eklendiğinde kodları hiçbir kapıda görünmüyordu — aynı boşluk sınıfı,
   * yeni bir dosyada tekrarlıyordu.
   */
  PURCHASE_NOT_FOUND: 'Alış belgesi bulunamadı. Silinmiş ya da bağlantı eskimiş olabilir.',
  PURCHASE_NOT_DRAFT:
    'Bu işlem yalnız TASLAK belgede yapılabilir. Onaylanmış bir alış kaydının mali kolonları dondurulur; değiştirmek için önce "Taslağa geri aç" deyin. ⚠ Geri açmak satış tarafında YOKTUR ve burada var olmasının sebebi şudur: mali gerçek tedarikçinin belgesidir, bizim kaydımız onun bir kopyasıdır.',
  PURCHASE_NOT_CONFIRMED:
    'Bu işlem yalnız ONAYLANMIŞ belgede yapılabilir; kayıt zaten taslak durumunda.',
  PURCHASE_NO_LINES:
    'Alış belgesinde satır yok. En az bir satır olmadan ne kutu ataması ne de indirim hesaplanabilir.',
  PURCHASE_SUPPLIER_NOT_FOUND:
    'Seçilen tedarikçi cari bulunamadı. Cari silinmiş ya da liste eskimiş olabilir.',
  CONTACT_NOT_SUPPLIER:
    'Seçilen cari tedarikçi olarak işaretlenmemiş. Cari detayından "Tedarikçi" kutusunu işaretleyin — aynı cari hem müşteri hem tedarikçi olabilir.',
  PURCHASE_UNKNOWN_NATURE:
    'Satırın alış niteliği tanınmıyor. Nitelik matrah kutusunu belirler: yeniden satılacak mal (81), hizmet ve çeşitli mal (82), yatırım (83).',
  PURCHASE_UNKNOWN_REGIME:
    'Satırın KDV rejimi tanınmıyor. Rejim ters yükümlülük kutusunu belirler (86 / 87 / 88) ve tedarikçinin ülkesinden TÜRETİLMEZ — nitelemeyi siz yaparsınız.',
  PURCHASE_UNKNOWN_VAT_RESTRICTION:
    'Satırın KDV kısıt kategorisi tanınmıyor. Liste Code md. 45’in kendi saydıklarıyla sınırlıdır ve genişletilemez.',
  PURCHASE_DEDUCTION_ABOVE_LEGAL_CAP:
    'Satırdaki KDV indirim oranı, hükmün izin verdiği ÜST SINIRI aşıyor. Code md. 45 §2 araçta indirimi "hiçbir hâlde" %50’yi aşamaz diye sınırlıyor; §3 ise tütün, yüksek alkollü içki, konaklama-yiyecek-içecek ve temsil giderlerinde indirimi tamamen kaldırıyor. ⚠ Bu bir TAVANDIR, taban değil: gerçek profesyonel kullanımınız daha düşükse aşağı inebilirsiniz.',
  PURCHASE_REVERSE_CHARGE_VAT_MISSING:
    'Ters yükümlülüklü bir alışta KDV 0 olamaz. Tedarikçinin faturasında KDV 0 yazar, ama bu alana SİZİN beyan edeceğiniz KDV girilir: matrah × oran (ör. 24,26 × %21 = 5.09). Aynı tutar hem ödenecek (kutu 55/56) hem indirilecek (kutu 59) olarak yazılır; net etki sıfırdır. 0 ile onaylanırsa kutu 88/87 dolar, vergi kutuları boş kalır ve beyan bloke olur.',

  // ── Fatura tahsilatı (M10)
  PAYMENT_AMOUNT_NOT_POSITIVE: 'Tahsilat tutarı sıfırdan büyük olmalı.',
  PAYMENT_ON_PROFORMA:
    'Proforma bir fatura DEĞİLDİR: KDV doğurmaz, alacak doğurmaz. Tahsilat ancak düzenlenmiş bir faturaya yazılır.',
  PAYMENT_INVOICE_NOT_ISSUED:
    'Yalnız DÜZENLENMİŞ belgeye tahsilat yazılır. Taslak fatura yasal olarak yoktur; önce faturayı düzenleyin.',
  PAYMENT_DATE_INVALID:
    'Tahsilat günü YYYY-AA-GG biçiminde olmalı. ⚠ Bu bir hukuki tarihtir: kasa esaslı belgede KDV o gün muaccel olur.',
  PAYMENT_NOT_FOUND: 'Tahsilat kaydı bulunamadı. Liste eskimiş olabilir.',
  PAYMENT_REMOVE_POSTED:
    'Bu tahsilat deftere kaydedilmiş; silinirse fişi defterde kalır ve aynı para ikinci kez tahsil edilip kaydedilebilir. Önce Defter → Yevmiye ekranında tahsilat fişini ters kayıtla kapatın, sonra silin.',

  PURCHASE_DUPLICATE_DOCUMENT_NUMBER:
    'Bu tedarikçinin aynı numaralı belgesi zaten kayıtlı. Bir tedarikçi aynı numarayı iki kez vermez: aynı fatura ikinci kez girilirse KDV İKİ KEZ indirilir ve iki kayıt da kendi içinde tutarlı göründüğü için fark beyandan sonra bile anlaşılmaz. Aynı belgeyi düzeltmek istiyorsanız mevcut kaydı açın; gerçekten ayrı bir belgeyse numarayı belgedeki gibi yazın.',

  INCOMING_DOCUMENT_NOT_FOUND: 'Gelen belge bulunamadı. Liste eskimiş olabilir.',
  INCOMING_ALREADY_PROCESSED:
    'Bu gelen belgeden zaten bir alış faturası üretilmiş. Bir belgeden en çok bir fatura ' +
    'doğar: aksi hâlde aynı tedarikçi faturası iki kez beyana girer ve iki kayıt da kendi ' +
    'içinde tutarlı göründüğü için mutabakatta fark edilmez.',
  INCOMING_DOCUMENT_UNREADABLE:
    'Gelen belge okunamadı; taslak üretilemedi. ⚠ BELGE KAYBOLMADI — ham hâli arşivde ' +
    'değişmez olarak duruyor ve elle girilebilir. Okuyucumuz bilerek DAR: anlamadığı her ' +
    'şeyi reddediyor (özellikle DTD, çünkü izlenmesi sunucudaki dosyaları okutabilir). ' +
    'Belgenin okunamaması onun geçersiz olduğu anlamına GELMEZ.',
  PURCHASE_ATTACHMENT_EXISTS:
    'Bu belgenin eki zaten yüklenmiş. Ek bir kez yazılır ve DEĞİŞTİRİLEMEZ: kaydın dayanağı olan belge sonradan başka bir dosyayla değiştirilebilseydi, kayıt hiçbir şeyin kanıtı olmazdı. Yanlış dosya yüklendiyse kaydı taslağa geri açıp yenisini oluşturun.',
  PURCHASE_ATTACHMENT_MISSING: 'Bu alış belgesine henüz ek (PDF ya da görüntü) yüklenmemiş.',
  ATTACHMENT_TYPE_NOT_ALLOWED:
    'Bu dosya türü kabul edilmiyor. Yalnız PDF, JPEG ve PNG yüklenebilir. ⚠ SVG ve HTML bilerek dışarıda: ikisi de betik taşıyabilir ve ek dosyası bir gün tarayıcıda gösterilirse saklanmış bir güvenlik açığına dönüşürdü.',
  ATTACHMENT_CONTENT_MISMATCH:
    'Dosyanın içeriği, belirtilen türle uyuşmuyor (ör. PDF denilen dosya aslında JPEG). İlk baytlar denetleniyor çünkü tür bilgisi gönderenin İDDİASIDIR. Arşivde PDF sanılan bir şeyin başka bir şey olması, denetimde belgeyi açamamak demektir.',
  ATTACHMENT_EMPTY: 'Dosya boş; yüklenecek bir içerik yok.',
  ATTACHMENT_TOO_LARGE:
    'Dosya 20 MB sınırını aşıyor. Taranmış bir belgeyi daha düşük çözünürlükle yeniden tarayın; okunabilirlik yeterli olmalı, arşiv kalitesi değil.',

  // ── Giderler (faturasız fişler)
  /*
   * ⚠ BU EKRANDA KDV İNDİRİMİYLE İLGİLİ TEK BİR HATA KODU YOK ve olmayacak:
   * sunucuda kolon, DTO'da alan, panelde girdi hiç açılmadı. AR n° 3 md. 3 §1,
   * 1° indirim hakkı için usulüne uygun bir FATURA elde tutulmasını şart
   * koşuyor; fiş bunu sağlamaz. Reddedilecek bir şey olmaması, kuralın
   * doğrulamayla değil ŞEMAYLA uygulandığının işareti.
   */
  EXPENSE_NOT_FOUND: 'Gider kaydı bulunamadı. Silinmiş ya da liste eskimiş olabilir.',
  EXPENSE_NOT_DRAFT:
    'Bu işlem yalnız TASLAK giderde yapılabilir. Onaylanan kaydın tutarı ve tarihi donar; değiştirmek için önce "Taslağa aç" deyin. Geri açmak serbesttir: mali gerçek fişin kendisidir, kaydımız onun bir kopyasıdır.',
  EXPENSE_NOT_CONFIRMED:
    'Bu işlem yalnız ONAYLANMIŞ giderde yapılabilir; kayıt zaten taslak durumunda.',
  EXPENSE_AMOUNT_NOT_POSITIVE:
    'Gider tutarı sıfırdan büyük olmalı. ⚠ Fiş İADESİ (negatif gider) bilerek modellenmedi: işareti tersine çeviren bir tutar, her tüketicinin işareti kendi uygulamasını gerektirir ve bir tanesi unuttuğu gün toplamlar sessizce şişer.',
  EXPENSE_ATTACHMENT_EXISTS:
    'Bu giderin fiş görüntüsü zaten yüklenmiş. Görüntü bir kez yazılır ve DEĞİŞTİRİLEMEZ: kaydın dayanağı olan fiş sonradan başka bir dosyayla değiştirilebilseydi, kayıt hiçbir şeyin kanıtı olmazdı.',
  EXPENSE_ATTACHMENT_MISSING: 'Bu gidere henüz fiş görüntüsü yüklenmemiş.',

  // ── Defter (yevmiye, hesap planı, mali yıl)
  JOURNAL_ENTRY_NOT_FOUND: 'Yevmiye fişi bulunamadı. Silinmiş ya da liste eskimiş olabilir.',
  JOURNAL_ENTRY_NOT_DRAFT:
    'Bu işlem yalnız TASLAK fişte yapılabilir. ⚠ Atılmış fişin "geri açılması" YOKTUR — alış faturasından ayrıldığımız nokta budur: orada kayıt tedarikçinin belgesinin bir kopyasıdır, burada kayıt BELGENİN KENDİSİDİR. Yanlış bir fişi düzeltmenin tek yolu TERS KAYIT atmaktır; ikisi de defterde kalır.',
  JOURNAL_ENTRY_NOT_POSTED:
    'Ters kayıt yalnız ATILMIŞ bir fiş için atılabilir. Fiş hâlâ taslaksa düzeltip yeniden atın; zaten ters çevrilmişse ikinci kez çevrilemez.',
  JOURNAL_ENTRY_UNBALANCED:
    'Fişin borç ve alacak toplamları eşit değil. Çift taraflı kayıtta bu bir tercih değil tanımdır: her tutarın bir karşılığı olmalı. Aradaki farkı mesajda görebilirsiniz.',
  JOURNAL_ENTRY_TOO_FEW_LINES:
    'Yevmiye fişi en az iki satır içermeli. Tek satırlı bir fiş dengeli OLAMAZ — eksik olan tutar değil, karşı satırdır.',
  JOURNAL_ENTRY_LINE_BOTH_SIDES:
    'Bir satırda hem borç hem alacak dolu. Böyle bir satır aslında netleştirilmiş İKİ satırdır ve defter-i kebirde iki ayrı hareket olarak görünmesi gerekir. Satırı ikiye bölün.',
  JOURNAL_ENTRY_LINE_EMPTY:
    'Bir satırda ne borç ne alacak var. Böyle bir satır denge denetimini geçer ama hiçbir şey söylemez; silin ya da tutarı girin.',
  JOURNAL_ENTRY_LINE_NEGATIVE:
    'Satır tutarı negatif olamaz. Ters yön, tutarı eksiye çevirerek değil, BORÇ yerine ALACAK (ya da tersi) yazılarak ifade edilir.',
  JOURNAL_ENTRY_DATE_INVALID: 'Fiş tarihi okunamadı. Biçim: YYYY-AA-GG.',
  JOURNAL_NOT_FOUND:
    'Dergi bulunamadı ya da pasif. Yerleşik dergiler: VK (satış), AK (alış), FIN (finans), DIV (çeşitli), OPB (açılış).',
  ACCOUNT_NOT_FOUND:
    'Hesap planında böyle bir kod yok. Hesap planı yerleşiktir ve panelden hesap açılmaz: yeni hesap bir migration ile gelir, böylece her kurulumda aynı olur.',
  ACCOUNT_INACTIVE: 'Bu hesap pasife alınmış; yeni kayıtlarda kullanılamaz.',
  FISCAL_YEAR_NOT_FOUND: 'Mali yıl bulunamadı.',
  FISCAL_YEAR_NOT_OPEN:
    'Bu tarihin mali yılı henüz açılmamış. Defter sayfasından ilgili yılı açın; yıl açmak geri alınabilir bir işlem değildir ama boş bir yıl da zararsızdır.',
  FISCAL_YEAR_CLOSED:
    'Mali yıl kapatılmış; o döneme kayıt atılamaz. Kapanış fişi hesapları sıfırlar ve sonradan atılan bir fiş o sıfırlamayı sessizce bozar — bilanço, kapanışta imzalanan hâlinden farklı olur.',
  OPENING_ENTRY_EXISTS:
    'Bu mali yılın açılış fişi zaten var. Bir yılda EN ÇOK BİR açılış olabilir: ikincisi tüm açılış bakiyelerini İKİ KATINA çıkarır ve mizan yine DENK görünürdü (her iki fiş de kendi içinde dengelidir), yani hata hiçbir kontrolde yakalanmazdı. Düzeltmek için mevcut açılış fişini TERS ÇEVİRİN, sonra yeniden girin.',
  IC_LISTING_EMPTY:
    'Bu dönemde AB içi işlem yok. Boş bir 723 listesi GÖNDERİLMEZ — "AB içi işlemim yok" demenin yolu listeyi hiç vermemektir.',
  IC_LISTING_HAS_PROBLEMS:
    'Listede çözülmemiş sorun var; dosya üretilmez. Eksik bir müşteri KDV numarası satırı sessizce düşürüp bildirilen toplamı olduğundan küçük gösterirdi.',
  /*
   * ⚠ BEYAN SORUNLARININ METİNLERİ DE BURADA — panelin İÇİNDE ayrı bir sözlükte
   * DEĞİL. Bir süre öyleydi: `vat-return-api.ts` içinde üç ayrı `PROBLEM_TEXT`
   * haritası vardı ve merkezî sözlük bu kodların HİÇBİRİNİ tanımıyordu. Ekranda
   * metin göründüğü için arıza görünmüyordu; ama aynı kod bir hata NESNESİ
   * içinde geldiğinde (XML indirme reddi gibi) operatör genel "beklenmeyen
   * hata" cümlesini görüyordu — yani panel aynı kuralı iki farklı şekilde
   * anlatıyordu. Sürüklenme testi kapıyı genişletince 11 kodun karşılığının
   * olmadığı ortaya çıktı.
   */
  VAT_GRID_NOT_IN_SCHEMA:
    'Bu kutu Intervat şemasında YOK ve dosya reddedilir. Şema tam 29 kutu tanıyor; özellikle kutu 91 diye bir şey yoktur.',
  VAT_GRID_NEGATIVE:
    'Kutu negatife topladı. Intervat şemasında tutarlar tanımı gereği pozitiftir (negatif değer XSD seviyesinde imkânsız): iade, negatif bir matrahla değil kredi notu kutularıyla (48/49/84/85 + 63/64) bildirilir.',
  VAT_REVERSE_CHARGE_EXCEEDS_INPUT_BASE:
    'Ters yükümlülüklü giriş matrahı (86+87+88), toplam giriş matrahını (81+82+83) aşıyor. Bu matematiksel olarak imkânsızdır ve tek bir anlamı vardır: kutu türetmesi "ya o ya bu" yapılmış, yani AB alımları 81/82/83’e HİÇ yazılmamış. Giriş matrahınız tüm yurtdışı alımlarınız kadar eksik beyan ediliyor.',
  VAT_REVERSE_CHARGE_TAX_MISSING:
    'Kutu 86 ya da 88 dolu ama kutu 55 boş. Ters yükümlülükte vergiyi siz borçlanırsınız; matrahı bildirip vergiyi bildirmemek beyanı kendi içinde çelişkili yapar.',
  VAT_IC_LISTING_REQUIRED:
    'Bu kutu doluysa AYRI bir beyan daha gerekiyor: AB içi işlemler listesi (723). Periyodik beyanınız kendi içinde geçerli — bu yüzden engellenmiyor — ama listeyi de vermeniz gerekir.',
  VAT_SETTLEMENT_BOX_MISSING:
    'Kutu 71 ve 72’den biri yazılmak zorunda. Intervat ikisi de boş olan bir beyanı reddeder; hiç işlem yapılmamış bir çeyrekte bile biri 0,00 olarak gider.',
  VAT_YEAR_OUT_OF_RANGE:
    'Yıl 2000-2100 aralığında olmalı. Yıllık müşteri listesi bir TAKVİM YILI ister; dönem anahtarı (2026Q4) değil.',
  /*
   * ⚠ 723 (AB İÇİ İŞLEMLER) — MÜŞTERİLERİ YABANCI OLAN LİSTE.
   */
  IC_CUSTOMER_VAT_MISSING:
    'Bu belgenin müşterisinde KDV numarası yok; AB listesine satır yazılamaz. Numara olmadan karşı taraf devlet işlemi eşleştiremez.',
  IC_CUSTOMER_VAT_BELGIAN:
    'Müşterinin numarası Belçika numarası. AB içi işlemler listesi tanımı gereği YABANCI müşteriler içindir (şema BE’yi kabul etmiyor); bu belge listeye düşüyorsa kutu eşlemesinde bir hata var.',
  IC_CUSTOMER_VAT_UNREADABLE:
    'Müşterinin KDV numarası okunamadı. Ülke ön eki + numara bekleniyor (ör. DE812871812).',
  IC_GRID_NOT_LISTABLE:
    'Bu belgenin kutusu AB listesine girmiyor. Listeye yalnız kutu 44 (hizmet) ve 46 (mal) girer.',
  /*
   * ⚠ 725 (YILLIK MÜŞTERİ LİSTESİ) — 723'ÜN AYNISI DEĞİL. İki listenin
   * `issuedBy` kuralı BİRBİRİNİN TERSİ: 723'e Belçikalı müşteri GİREMEZ,
   * 725'e yalnız Belçikalı müşteri girer. Mesajlar bu yüzden ayrı yazıldı;
   * "aynı şeyi söylüyorlar" diye birleştirmeyin.
   */
  CLIENT_LISTING_HAS_PROBLEMS:
    'Listede çözülmemiş sorun var; dosya üretilmez. Sorunlu bir satırı sessizce düşürmek, bildirilen ciroyu olduğundan küçük gösterir.',
  CLIENT_LISTING_VAT_MISSING:
    'Bu belgenin müşterisinde KDV numarası yok. 725 listesi müşteriyi numarasıyla tanır; numarası olmayan bir satır listeye giremez. Müşteri gerçekten KDV mükellefi değilse (özel kişi) o belge zaten bu listeye ait değildir — carinin tipini düzeltin.',
  CLIENT_LISTING_VAT_NOT_BELGIAN:
    'Müşterinin numarası yabancı. Yıllık müşteri listesi yalnız BELÇİKALI mükellefler içindir (şema BE dışını kabul etmiyor); AB müşterilerinin yeri 723 listesidir. Bu belge buraya düşüyorsa kutu eşlemesinde bir hata var.',
  CLIENT_LISTING_VAT_UNREADABLE:
    'Müşterinin KDV numarası okunamadı ya da mod-97 sağlaması tutmuyor. Böyle bir numara portalda reddedilir ve hangi belgeden geldiği orada görünmez; carinin numarasını düzeltin.',
  /*
   * ⚠ M7b — BANKA ve CODA.
   */
  BANK_ACCOUNT_NOT_FOUND: 'Banka hesabı bulunamadı.',
  BANK_ACCOUNT_IBAN_INVALID: 'IBAN biçimi geçersiz. Ülke kodu + rakam/harf bekleniyor.',
  BANK_ACCOUNT_IBAN_TAKEN:
    'Bu IBAN zaten kayıtlı. Aynı hesabı iki kez açmak CODA eşleştirmesini bozar: ekstre birine düşer, faturalar ötekine bakar.',
  BANK_TRANSACTION_NOT_FOUND: 'Banka hareketi bulunamadı.',
  BANK_TRANSACTION_ALREADY_MATCHED:
    'Bu hareket zaten tam eşleşmiş; yok sayılamaz. Önce tahsislerini kaldırın.',
  CODA_FILE_EMPTY: 'CODA dosyası boş.',
  CODA_FILE_ALREADY_IMPORTED:
    'Bu dosya daha önce yüklendi — baytı baytına aynısı. Yeniden yüklemek hareketleri çoğaltmaz ama işe de yaramaz; bankadan yeni bir ekstre indirin.',
  /*
   * ⚠ BU KOD ÇOĞUNLUKLA BAKİYE UYUŞMAZLIĞIDIR — ve o, dosyanın kendi
   * denetiminin çalıştığı anlamına gelir.
   */
  CODA_FILE_INVALID:
    'CODA dosyası okunamadı ve HİÇBİR hareket yazılmadı. En sık sebep, ekstrenin kendi bakiyesinin tutmaması: eski bakiye + hareketler, dosyadaki yeni bakiyeye eşit değil. Bu, dosyanın bozuk olduğunu ya da okuyucunun bir satırı yanlış yorumladığını gösterir; yarım içe aktarmaktansa hiç aktarmamak doğrudur. Ayrıntı mesajda yazıyor — bankaya iletirken o satırı verin.',
  CODA_STATEMENT_DATE_MISSING:
    'Ekstrede tarih yok. Hareketlerin hangi yıla ait olduğu belirlenemez ve ekstre numarası her yıl 001’e döndüğü için yılsız kayıt, geçen yılın ekstresiyle çakışırdı.',
  CODA_SUB_CENT_AMOUNT:
    'Dosyada kuruşun altında bir tutar var (CODA üç ondalık taşır, kayıtlar iki). Yuvarlamak mutabakatta aylar sonra “bir kuruş tutmuyor” olarak görünürdü; bu yüzden içe aktarma durdu. Bankanızla görüşün.',
  PAYMENT_ALLOCATION_NOT_FOUND: 'Tahsis kaydı bulunamadı.',
  PAYMENT_ALLOCATION_AMOUNT_NOT_POSITIVE:
    'Tahsis tutarı pozitif olmalı. Yön hareketin işaretinden gelir (giriş +, çıkış −), tahsisten değil.',
  /*
   * ⚠ BU KAPI MUTABAKATIN KENDİSİNİ KORUYOR.
   */
  PAYMENT_ALLOCATION_EXCEEDS_TRANSACTION:
    'Tahsislerin toplamı hareketi aşıyor. Aşmasına izin verilseydi “şu kadar tahsil ettik” ile “şu kadar para geldi” ayrışır ve hiçbir rapor farkı açıklayamazdı. Tutarı düşürün ya da önceki tahsislerden birini kaldırın.',
  /*
   * ⚠ M6b — İŞLER ve İŞ KAYITLARI.
   */
  PROJECT_NOT_FOUND: 'Proje bulunamadı.',
  PROJECT_CODE_TAKEN: 'Bu proje kodu zaten kullanılıyor. Kod tekildir.',
  PROJECT_CONTACT_REQUIRED:
    'Müşteri işinin carisi olmak zorunda. Carisiz bir proje faturaya dönüştürülemez ve "kime yaptım" sorusu cevapsız kalır. Gerçekten iç bir çalışmaysa proje türünü İÇ (INTERNAL) yapın.',
  PROJECT_ITEM_REQUIRED:
    'Faturaya dönüştürmek için bir katalog kalemi gerekiyor: fatura satırının KDV oranı, birimi ve adı oradan gelir. Projeye varsayılan bir kalem seçin ya da bu işlemde kalemi belirtin.',
  WORK_ENTRY_NOT_FOUND: 'İş kaydı bulunamadı.',
  WORK_ENTRIES_EMPTY: 'Faturalanacak iş kaydı seçilmedi.',
  WORK_ENTRY_RATE_REQUIRED:
    'Saatlik oran gerekiyor. Ne bu kayıtta ne de projede oran var; sıfır varsaymak, faturalanabilir bir işi sessizce bedava yapmak olurdu.',
  /*
   * ⚠ BU KOD ÇİFT FATURALAMAYI ENGELLİYOR — bu ekranın en pahalı hatası.
   */
  WORK_ENTRY_ALREADY_BILLED:
    'Bu iş zaten faturalandı ve faturalanmış bir kayıt değiştirilemez, silinemez, ikinci kez faturalanamaz. Aynı işi iki kez faturalamak müşteriye çift fatura kesmek demektir ve iki belge de kendi içinde tutarlı göründüğü için fark ancak müşteri itiraz edince anlaşılır. Fatura hâlâ TASLAKSA onu silin — bağ kopar ve iş yeniden faturalanabilir hâle gelir; DÜZENLENMİŞSE yol kredi notudur.',
  WORK_ENTRY_NOT_BILLABLE:
    'Bu iş "faturalanamaz" olarak işaretli (garanti, iç çalışma vb.) ve faturaya giremez. Yanlışlıkla işaretlendiyse kaydı düzenleyip faturalanabilir yapın.',
  WORK_ENTRY_WRONG_PROJECT:
    'Seçilen iş kayıtlarından biri bu projeye ait değil. Karışık bir küme faturayı yanlış cariye keserdi — ve fatura düzenlendikten sonra bu düzeltilemez.',
  /*
   * ⚠ M6a — ABONELİKLER. Bu kodların hepsi bir TASLAK üretme denemesinde
   * çıkar; hiçbiri düzenlenmiş bir belgeyi ilgilendirmez.
   */
  SUBSCRIPTION_NOT_FOUND: 'Abonelik sözleşmesi bulunamadı.',
  SUBSCRIPTION_NO_LINES: 'Sözleşmede en az bir satır olmalı.',
  SUBSCRIPTION_END_BEFORE_START: 'Bitiş tarihi başlangıçtan önce olamaz.',
  SUBSCRIPTION_NOT_ACTIVE:
    'Yalnız yürürlükteki bir sözleşme fatura üretir. Duraklatılmışsa sürdürün; bitmişse yeni bir sözleşme açın — bitmiş sözleşme yeniden açılmaz, çünkü aradaki dönemlerin faturalanıp faturalanmadığı belirsiz kalırdı.',
  SUBSCRIPTION_ALREADY_ENDED:
    'Bu sözleşme bitmiş. Bitmiş sözleşme yeniden açılmaz: aradaki dönemlerin faturalanıp faturalanmadığı belirsiz kalır. Devam edecekse YENİ bir sözleşme açın — sözleşme geçmişi de böylesi doğru gösterir.',
  /*
   * ⚠ BU İKİ KOD BİR HUKUKİ SINIRI ANLATIYOR, BİR YAZILIM KATILIĞINI DEĞİL.
   */
  SUBSCRIPTION_PERIOD_NOT_BILLABLE:
    'Bu dönem henüz faturalanamaz. Sondan faturalanan bir abonelikte dönem BİTMEDEN fatura üretilmez: teslim tarihi gelecekte bir gün olur ve beyan, henüz verilmemiş bir hizmeti bildirir. Önden faturalananda ise dönem başlamadan üretilmez.',
  SUBSCRIPTION_PERIOD_ALREADY_BILLED:
    'Bu dönem zaten faturalandı. Aynı dönemi ikinci kez üretmek müşteriye çift fatura gitmesi demektir ve ikisi de "doğru" göründüğü için fark ancak müşteri şikâyet edince anlaşılır. Üretilen taslak yanlışsa onu silin — silince dönem yeniden üretilebilir hâle gelir.',
  SUBSCRIPTION_PERIOD_AFTER_END:
    'Sıradaki dönem, sözleşmenin bitiş tarihinden sonraya düşüyor. Verilmeyen bir hizmet faturalanamaz; sözleşme fiilen bitmiş demektir.',
  /*
   * ⚠ M5e — BEYAN KAYDI. Bu kodların çıktığı an, operatörün beyanı vermeye
   * çalıştığı andır: mesajlar ne yapılacağını SÖYLEMEK zorunda, çünkü
   * muhasebecisi yok ve sürenin son günü olabilir.
   */
  VAT_DECLARATION_EXISTS:
    'Bu dönemin beyan kaydı zaten var. Bir dönemin yürürlükteki beyanı tektir. Yanlışlıkla hazırlandıysa (henüz makbuz yüklenmediyse) kaydı silip yeniden hazırlayabilirsiniz; makbuz yüklendiyse artık silinemez ve düzeltme yolu ayrı bir beyandır.',
  VAT_DECLARATION_NOT_FOUND: 'Beyan kaydı bulunamadı.',
  VAT_DECLARATION_NOT_PREPARED:
    'Bu işlem yalnız HENÜZ GÖNDERİLMEMİŞ bir kayıtta yapılabilir. Makbuzu yüklenmiş bir beyan silinemez, ikinci kez gönderilemez ve durumu geri çekilemez — verilmiş bir beyanı verilmemiş göstermenin yolu yoktur.',
  VAT_DECLARATION_REPLACE_PERIODIC_ONLY:
    'Yalnız periyodik KDV beyanı bir öncekini değiştirebilir. Intervat’ın düzeltme mekanizması (`ReplacedVATDeclaration`) periyodik beyanın şemasına aittir; 723 ve 725 şemalarında böyle bir eleman yok. Listede yanlış varsa yol, listeyi yeniden göndermektir.',
  VAT_DECLARATION_ALREADY_REPLACED:
    'Bu beyan zaten bir düzeltmeyle değiştirilmiş. Aynı belgeye iki düzeltme bağlanamaz: hangisinin geçerli olduğu Intervat’a söylenemez ve zincir çatallanır. Düzeltmeyi, yürürlükteki (en son) beyan üzerinden yapın.',
  VAT_DECLARATION_CORRECTION_PENDING:
    'Bu dönem için hazırlanmış ama henüz gönderilmemiş bir düzeltici beyan zaten var. Onu Intervat’a yükleyip makbuzunu yükleyin ya da kaydı silip yeniden hazırlayın — aynı beyana aynı anda iki düzeltme bağlanamaz.',
  VAT_DECLARATION_REPLACE_PERIOD_MISMATCH:
    'Düzeltici beyan yalnız AYNI dönemin beyanını değiştirebilir. Başka bir dönemin beyanını “düzeltmek”, o dönemin geçerli beyanını sessizce değiştirmek olurdu.',
  VAT_DECLARATION_REPLACE_TARGET_NOT_SUBMITTED:
    'Yalnız GÖNDERİLMİŞ (makbuzu yüklenmiş) bir beyan düzeltilir. Henüz gönderilmemiş bir kaydın düzeltmesi yoktur: kaydı silip yeniden hazırlayın.',
  VAT_DECLARATION_REPLACE_REFERENCE_MISSING:
    'Düzeltilen beyanın Intervat referansı gerekiyor. Orijinal beyanın Intervat makbuzunda yazar (ör. 12345-1234567890-123456); “Bu beyanın Intervat referansı” alanına girin. Referanssız bir dosya Intervat’a düzeltme olarak değil, YENİ ve ayrı bir beyan olarak gider.',
  VAT_DECLARATION_REFERENCE_INVALID:
    'Intervat referansı şemanın beklediği biçimde değil: rakamlar, tire, 10 hane, tire, 6 hane (ör. 12345-1234567890-123456). Makbuzdaki “BE…” ile başlayan bir numara bu alana uymaz.',
  VAT_DECLARATION_REFERENCE_MISMATCH:
    'Girdiğiniz referans, bu beyana daha önce kaydedilmiş Intervat referansıyla tutmuyor. Kayıtlı referans bir kez yazılır ve değiştirilemez; makbuzu kontrol edin.',
  INTERVAT_DECLARATION_REFERENCE_INVALID:
    'Düzeltilen beyanın Intervat referansı şemaya uymuyor (rakamlar-10 hane-6 hane). Dosya üretilmedi; referansı makbuzdan kontrol edin.',
  /*
   * ⚠ BU MESAJ BİR HUKUKİ SINIRI ANLATIYOR, BİR YAZILIM SINIRINI DEĞİL — ve
   * mevcut OLMAYAN bir özelliğe yönlendirmiyor: kutu 61/62 akışı henüz yok.
   */
  VAT_DECLARATION_DEADLINE_PASSED:
    'Beyan süresi doldu; düzeltici beyan verilemez. 1 Ocak 2025’ten beri, süresi geçmiş bir dönem için “öncekini değiştiren” beyan kabul edilmiyor — düzeltme bir SONRAKİ periyodik beyanın kutu 61/62’sine girer (KDV beyanı ekranındaki “Kutu 61/62 düzeltmeleri”).',
  VAT_RECEIPT_EMPTY: 'Makbuz dosyası boş.',
  VAT_RECEIPT_TOO_LARGE: 'Makbuz dosyası çok büyük (en çok 20 MB).',
  /*
   * ⚠ TÜR BAYTLARDAN DOĞRULANIYOR, İSTEMCİNİN SÖYLEDİĞİNDEN DEĞİL.
   */
  VAT_RECEIPT_NOT_PDF:
    'Makbuz PDF değil. Intervat’ın imzalı PDF makbuzu, beyanın verildiğinin TEK hukuki kanıtıdır; ürettiğimiz XML kanıt sayılmaz (onu biz yazdık). Dosyanın gerçekten PDF olduğu içeriğinden doğrulanıyor — portaldan indirdiğiniz makbuzu yükleyin, ekran görüntüsünü değil.',
  VAT_RECEIPT_MISSING: 'Bu beyana henüz makbuz yüklenmemiş.',
  /*
   * ⚠ M12 — KDV'NİN DEVLETE FİİLEN ÖDENMESİ. Beyanı hazırlamak ve göndermek
   * KDV BORCUNU SIFIRLAMAZ; borç ancak devlete gerçekten para gönderilince
   * kapanır. Bu kodlar "ödeme" ile "beyan" adımlarının karıştırılmasını
   * engelliyor.
   */
  VAT_PAYMENT_NOT_PERIODIC:
    'Yalnız periyodik KDV beyanının ödenecek tutarı vardır. AB içi işlemler listesi (723) ve yıllık müşteri listesinin (725) ödenecek bir KDV’si yok — ödeme kaydı yalnız periyodik beyanda tutulur.',
  VAT_PAYMENT_NOT_SUBMITTED:
    'Ödeme yalnız GÖNDERİLMİŞ bir beyana kaydedilir. Önce makbuzu yükleyin (beyanı verin); "beyan etmeden ödedik" gibi tarihi tersine çeviren bir kayıt tutulamaz.',
  VAT_PAYMENT_NOT_POSITIVE: 'Ödeme tutarı sıfırdan büyük olmalı.',
  VAT_PAYMENT_NOT_FOUND: 'Ödeme kaydı bulunamadı — silinmiş olabilir.',
  /*
   * ⚠ "OKUYAMADIM" DEĞİL, "BU BİZİM GÖNDERDİĞİMİZ DOSYA DEĞİL". Yapılacak şey
   * de bambaşka: disk kontrolü değil, yedekten geri yükleme.
   */
  ARCHIVE_SHA256_MISMATCH:
    'Arşivdeki dosya, kaydedildiği andaki özetiyle TUTMUYOR — yani diskteki baytlar gönderdiğimiz belge değil. Bu bir okuma hatası değil, bütünlük ihlalidir: dosya bozulmuş ya da değiştirilmiş olabilir. Yedekten geri yükleyin ve durumu kayda geçirin.',
  /*
   * ⚠ M5f — KUTU 61/62 DÜZELTMELERİ. Bu ekranın kullanıcısı, hatasını fark
   * etmiş ve düzeltmeye çalışan biri; mesajlar YAPILACAK ŞEYİ söylemek zorunda.
   */
  VAT_ADJUSTMENT_NOT_FOUND: 'Düzeltme kaydı bulunamadı.',
  VAT_ADJUSTMENT_AMOUNT_NOT_POSITIVE:
    'Tutar pozitif olmalı. "Eksi 61" diye bir şey yoktur: Hazine lehine düzeltme kutu 61’e, mükellef lehine olan kutu 62’ye yazılır ve ikisi de pozitiftir.',
  VAT_ADJUSTMENT_ALREADY_CANCELLED: 'Bu düzeltme zaten iptal edilmiş.',
  VAT_ADJUSTMENT_PERIOD_BEFORE_ORIGIN:
    'Düzeltme, hatanın yapıldığı dönemden ÖNCEKİ bir döneme yazılamaz. Düzeltmenin gireceği dönem, hatanın dönemiyle aynı ya da ondan sonraki bir dönem olmalı.',
  /*
   * ⚠ KARŞI HESABI YAZILIM SEÇMEZ — bu mesaj o kararın operatöre görünen yüzü.
   */
  VAT_ADJUSTMENT_COUNTER_IS_VAT_ACCOUNT:
    'Karşı hesap bir KDV hesabı olamaz. Düzeltmenin KDV ayağını yazılım kendisi yazıyor (61 → hesaplanan KDV, 62 → indirilecek KDV); sizden istenen, düzeltmenin KARŞILIĞININ gideceği hesap — batık alacakta zarar hesabı, revizyonda ilgili gider/varlık hesabı gibi. İki ayağı da KDV yaparsanız fiş kendi içinde döner ve düzeltme hiçbir gelir/gider hesabına dokunmaz.',
  VAT_ADJUSTMENT_PERIOD_DECLARED:
    'Bu dönemin beyanı verilmiş; düzeltme artık o döneme yazılamaz. Verilmiş bir beyanın dayanağını sonradan değiştirmek, arşivdeki dosya ile kayıtları ayrıştırır. Düzeltmeyi bir SONRAKİ döneme yazın — hukuken de yol budur.',
  VAT_ADJUSTMENT_PERIOD_PREPARED:
    'Bu dönem için hazırlanmış bir beyan kaydı var ve XML’i çoktan arşivlendi; şimdi düzeltme eklenirse arşivdeki dosya kayıtlardaki gerçeği anlatmaz. Önce o beyan kaydını silin (henüz gönderilmediği için silinebilir), düzeltmeyi ekleyin, sonra beyanı yeniden hazırlayın.',
  VAT_RETURN_NOT_SUBMITTABLE:
    'Beyanda bloke edici var; reddedileceği bilinen bir dosya üretilmez. Yukarıdaki kırmızı maddeleri düzeltin — her birinin sebebi orada yazılı.',
  INTERVAT_VAT_NUMBER_INVALID:
    'Ayarlardaki KDV numarası Intervat şemasının istediği biçimde değil. Şema noktasız 10 hane istiyor ve mod-97 sağlamasının tutması gerekiyor; Ayarlar → şirket bilgilerinden düzeltin.',
  INTERVAT_GRID_NOT_IN_SCHEMA:
    'Beyanda Intervat şemasında olmayan bir kutu var; dosya reddedilirdi. Şema tam 29 kutu tanıyor ve kutu 91 diye bir şey yoktur.',
  INTERVAT_SETTLEMENT_BOX_MISSING:
    'Kutu 71 ya da 72 yazılmak zorunda; Intervat ikisi de boş olan bir beyanı reddeder.',
  VAT_PERIOD_KEY_INVALID: 'Dönem anahtarı çeyreklikte 2026Q4, aylıkta 2026M10 biçiminde olmalı.',
  REPORT_DATE_INVALID: 'Rapor tarihi YYYY-AA-GG biçiminde olmalı.',
  FISCAL_YEAR_OUT_OF_RANGE: 'Mali yıl 2000-2100 aralığında olmalı.',
  // ── Duran varlıklar ve amortisman (M9a)
  FIXED_ASSET_NOT_FOUND: 'Duran varlık bulunamadı. Liste eskimiş olabilir.',
  FIXED_ASSET_LINE_ALREADY_REGISTERED:
    'Bu alış satırı zaten duran varlık defterine alınmış. Bir satırdan en çok BİR varlık doğar: aksi hâlde aynı ekipmanın amortismanı iki kez indirilir ve iki kayıt da kendi içinde tutarlı göründüğü için fark yıl sonuna kadar görünmez.',
  FIXED_ASSET_DISPOSED:
    'Bu varlık elden çıkarılmış; mali kolonları değiştirilemez. Kazanç/zarar o rakamlardan hesaplandı. Düzeltmek için önce elden çıkarmayı geri alın.',
  FIXED_ASSET_DISPOSAL_BEFORE_ACQUISITION: 'Elden çıkarma tarihi edinme tarihinden önce olamaz.',
  PACKAGE_TOO_LARGE:
    'Paket, tek bir ZIP dosyasının taşıyabileceği sınırı aşıyor. Belgeleri hariç tutarak (yalnız defterler) yeniden deneyin; ham belgeleri ayrıca verebilirsiniz. ⚠ Kırpılmış bir arşiv üretmektense hata vermeyi seçiyoruz: bozuk bir paket, ancak karşı tarafta açılmadığında anlaşılır.',

  // ── Envanter defteri (M9d)
  INVENTORY_NOT_FOUND: 'Bu yıl için çıkarılmış bir envanter yok.',
  INVENTORY_ALREADY_TAKEN:
    'Bu yılın envanteri zaten çıkarılmış. Envanter belli bir GÜNDE beyan edilen bir dökümdür: düzeltmek için mevcut kaydı sebebiyle birlikte İPTAL edin, sonra yenisini çıkarın — satır defterde kalır.',

  // ── Yıl sonu kapanışı (M9c)
  YEAR_END_NOT_READY:
    'Yıl kapatılamaz: önce engelleri giderin. Eksik bir defteri kapatmak eksikliği KALICI kılar — kapatılmış yıla kayıt atılamaz.',
  YEAR_END_NOTHING_TO_CLOSE:
    'Bu yılda kapatılacak sonuç hesabı yok: gelir ve gider hesaplarının hiçbirinde hareket görünmüyor.',
  YEAR_END_NOT_CLOSED: 'Bu yıl kapatılmamış; geri açılacak bir kapanış fişi yok.',

  DEPRECIATION_YEAR_NOT_ENDED:
    'Yıl bitmeden amortisman fişi atılmaz. Amortisman yıl sonunda ayrılan bir karardır; yıl içinde atılan fiş, sonradan değişebilecek bir cetvele dayanır (varlık satılabilir, oran düzeltilebilir) ve ters çevrilmek zorunda kalır.',
  DEPRECIATION_ALREADY_POSTED:
    'Bu yılın amortisman fişi zaten atılmış. İkinci bir fiş amortismanı İKİ KATINA çıkarır ve mizan yine denk görünür — fark yıl sonuna kadar fark edilmez. Düzeltmek için fişi TERS ÇEVİRİN, sonra yeniden atın.',
  DEPRECIATION_NOTHING_TO_POST:
    'Bu yıl amortisman ayrılacak varlık yok. Deftere alınmamış bir yatırımınız varsa önce onu ekleyin.',

  FIXED_ASSET_PLAN_INVALID:
    'Amortisman planı hesaplanamıyor. En sık sebebi: kalıntı değerin maliyete eşit ya da ondan büyük olması, ya da oranın 0 olması. ⚠ Oran kanunda yazmaz — varlığın GERÇEK kullanım ömrüne uygun bir yüzde girin.',

  TAX_RESERVE_YEAR_UNSUPPORTED:
    'Bu gelir yılının vergi ve prim sabitleri henüz tanımlı değil. Dilimler, muafiyet eşiği, prim tavanları ve gider forfaiti HER OCAK yeniden endekslenir; eski yılın tablosuyla hesaplamak doğru görünen ama yanlış bir rakam üretirdi. O yılın RSVZ baremi ve endekslenmiş gelir vergisi tutarları programa girilmeden bu tahmin yapılamaz.',
  DOCUMENT_ALREADY_POSTED:
    'Bu belge zaten deftere kaydedilmiş. Bir belgeden en çok BİR yevmiye fişi doğar: aksi hâlde ciro iki katına çıkar ve mizan yine DENGELİ görünür (iki fiş de kendi içinde dengelidir), yani fark yıl sonuna kadar görünmez. Kayıt yanlışsa fişi TERS ÇEVİRİN; ondan sonra belge yeniden kaydedilebilir.',
  DOCUMENT_NOT_POSTABLE_YET:
    'Bu belge henüz deftere girecek durumda değil. Satış faturası DÜZENLENMİŞ, alış belgesi ve gider ONAYLANMIŞ olmalı — taslakta tutarlar donmamıştır. Proforma ise hiç girmez: fatura değildir, KDV doğurmaz.',
  DOCUMENT_SOURCE_NOT_POSTABLE:
    'Bu kaynak türü deftere kaydedilemez. Bugün yalnız satış faturası, alış faturası ve gider kaydedilebiliyor.',
  POSTING_NO_REVENUE_ACCOUNT:
    'Bu KDV muamelesi için hasılat hesabı tanımlı değil. Md. 44 muafiyetinde hangi bende dayanıldığı işlem bazında değişir ve hasılat hesabı da onunla seçilmelidir; muafiyet rejimi (56bis) ise bu işletmede kapalı. Uydurulmuş bir hesap, yıl sonunda hiçbir yere oturmayan bir bakiye bırakırdı.',
  POSTING_NO_EXPENSE_ACCOUNT: 'Satır için gider hesabı belirlenemedi.',
  POSTING_MIXED_REGIME_UNSUPPORTED:
    "Bu belgede hem KDV'li hem ters yükümlü satır var ve deftere kaydedilemiyor. Sebep tahmin edilmemesi gerektiği: tedarikçinin gerçekten TAHSİL ETTİĞİ KDV payı hiçbir dondurulmuş kolonda yok, hesaplamak yanlış bir tedarikçi bakiyesi bırakırdı. Tek bir tedarikçi faturasında bu bileşim pratikte olmaz — iki ayrı belge girin.",
  POSTING_UNKNOWN_REGIME: 'Satırın KDV rejimi tanınmıyor; ters yükümlülük bacağı yazılamaz.',
  POSTING_PAYMENT_METHOD_UNMAPPED:
    'Kart ve “diğer” tahsilatta paranın düştüğü hesap yöntemden çıkarılamaz (para önce bir aracıya — ödeme kuruluşu, Stripe bakiyesi — düşer). Tahsilat satırında hesabı yazın (ör. 499000 askı hesabı) ve yeniden “Deftere kaydet” deyin. Banka ya da kasa tahsilatıysa yöntemi düzeltin.',
  PAYMENT_ACCOUNT_INVALID:
    'Bu hesap tahsilat için seçilemez. Hesap planında olmalı, sınıf 4 ya da 5 (para/ara hesap) olmalı; alacak hesabı (400000) ve KDV hesapları seçilemez.',
  PAYMENT_ACCOUNT_NOT_ALLOWED:
    'Hesap yalnız kart ve “diğer” tahsilatta seçilir; banka ve kasa tahsilatının hesabı yöntemden kesin olarak gelir.',
  JOURNAL_ENTRY_NUMBER_COLLISION:
    'Sayacın verdiği fiş numarası defterde zaten var. Bu, bir fişin SAYAÇ KULLANILMADAN yazıldığı anlamına gelir (elle SQL, yarım kalmış bir içe aktarma, kısmi geri yükleme). ⚠ Yazılım sessizce bir sonraki numaraya geçmez: öyle yapsaydı defterde açıklanamayan bir boşluk kalır ve asıl arıza gizlenirdi — Belçika TVA denetiminin ilk sorduğu şey tam olarak o boşluktur. Sayaç ile defter karşılaştırılıp sebebi bulunmalı.',

  // ── e-Fatura (UBL) eşleyicisi
  /*
   * ⚠ BU BLOK ÖLÇÜLMÜŞ BİR BOŞLUĞU KAPATIYOR: eşleyicinin 45 kodunun HİÇBİRİ
   * sözlükte yoktu. Kodlar `einvoice.service` tarafından
   * `ConflictException({ code: err.code })` ile aynen dışarı veriliyor, yani
   * panele ÜST DÜZEY `code` olarak ulaşıyorlar — ve karşılığı olmayan kod
   * "Beklenmeyen bir hata oluştu." basar. Operatör ne olduğunu, ne yapması
   * gerektiğini, hatta bunun bir sunucu arızası OLMADIĞINI bile
   * öğrenemiyordu; büyük olasılıkla aynı düğmeye tekrar tekrar basıyordu.
   *
   * ⚠ ÇOĞU MESAJ "BELGE DONDU" DİYE BİTER ve bu bilinçli. Eşleyici
   * DÜZENLENMİŞ belgeyle çalışır: buraya düşen arızaların çoğu artık
   * düzeltilemez ve operatörün öğrenmesi gereken ilk şey, harcayacağı emeğin
   * nereye gideceğidir — cariyi düzeltmek geçmiş belgeyi kurtarmaz.
   */
  UBL_ENDPOINT_BE_NUMBER_INVALID:
    'Alıcının Peppol kimliği geçersiz: 0208 şeması ayraçsız 10 haneli işletme numarası ister ve son iki hane bir sağlama basamağıdır — bir hane şaşmış olabilir. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır. Yeni belgeler için cari detayından kimliği düzeltin.',
  UBL_ENDPOINT_MALFORMED:
    'Peppol kimliği "<4 haneli şema>:<değer>" biçiminde değil (örn. 0208:1041328256). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_BUYER_ENDPOINT_MISMATCH:
    'Belgeye donmuş alıcı Peppol kimliği ile carideki kimlik AYRIŞMIŞ. Belge kendi dondurduğu adrese gönderilir; carinin bugünkü kimliği geçmiş belgeyi değiştirmez. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_SELLER_ENDPOINT_MISMATCH:
    'Belgeye donmuş SATICI Peppol kimliği, Ayarlardaki işletme numarasından türetilenle uyuşmuyor. İşletme numarası değiştiyse geçmiş belgeler eski kimlikle donmuştur ve öyle kalmalıdır.',
  UBL_BUYER_ELECTRONIC_ADDRESS_NOT_FROZEN:
    'Bu belge, alıcının elektronik adresi (BT-49) belgeye donmadan önce düzenlenmiş; Peppol alıcı adresi olmayan belgeyi kabul etmez. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_SELLER_ELECTRONIC_ADDRESS_NOT_FROZEN:
    'Bu belge, satıcının elektronik adresi (BT-34) belgeye donmadan önce düzenlenmiş. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_SELLER_ADDRESS_NOT_FROZEN:
    'Bu belge, satıcının yapılandırılmış adresi (sokak / posta kodu / şehir / ülke) belgeye donmadan önce düzenlenmiş; EN 16931 adres bloğunu ve ülke kodunu zorunlu kılar. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_BUYER_VAT_REQUIRED:
    'Bu KDV muamelesi alıcının KDV numarasını zorunlu kılar (BR-AE-03 / BR-IC-03) ama belgeye donmamış. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_PEPPOL_REFERENCE_REQUIRED:
    'Peppol, alıcı referansı (BT-10) ya da sipariş referansı (BT-13) taşımayan belgeyi REDDEDER (PEPPOL-EN16931-R003) ve bu belgede ikisi de yok. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_BUYER_ADDRESS:
    'Belgeye donmuş alıcı adresi eksik (KB nr. 1 md. 5 §1 + EN 16931 BG-8). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_BUYER_COUNTRY:
    'Belgeye donmuş alıcı ülke kodu eksik; EN 16931 adres bloğunda ülkeyi ZORUNLU kılar. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_SELLER_VAT_NUMBER:
    'Belgeye donmuş satıcı KDV numarası eksik. Ayarlardaki numara sonradan girildiyse geçmiş belgeler onsuz donmuştur. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_SELLER_ENTERPRISE_NUMBER:
    'Belgeye donmuş satıcı işletme numarası eksik (WER md. III.25 §1). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_SELLER_IBAN:
    'Ödeme talep eden belgede satıcı IBAN’ı yok (WER md. III.25 §2). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_IBAN_MENTION_MISMATCH:
    'Belgeye donmuş IBAN ibaresi ile IBAN kolonu FARKLI hesap gösteriyor. Belgenin iki temsili aynı hesabı göstermek zorunda; bu belge gönderilemez.',
  UBL_BANK_ACCOUNT_MISSING:
    'Ödeme talep eden belgede banka hesabı ibaresi dondurulmamış (WER md. III.25 §2). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_VAT_NUMBER_NOT_PREFIXED:
    'KDV numarası ülke önekiyle başlamıyor (BR-CO-09). Yunanistan’ın ISO kodu GR, KDV öneki EL’dir — karıştırılmış olabilir. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_DOCUMENT_NOT_ISSUED:
    'Taslağın e-faturası üretilmez: numarası yoktur, KDV kararı ve zorunlu ibaresi henüz donmamıştır. Önce faturayı düzenleyin.',
  UBL_PROFORMA_NOT_SENDABLE:
    'Proforma bir KDV belgesi değildir ve Peppol’e gönderilmez. Bu bir sunucu arızası değildir.',
  UBL_PREPAID_ON_NON_INVOICE:
    'Önceden tahsil edilmiş tutar (BT-113) yalnız faturada bulunabilir; bu belgede olmamalıydı. Bu bir veri tutarsızlığıdır — belge kesilmeden önce düzeltilmeliydi.',
  UBL_NO_LINES: 'Belgede satır yok; EN 16931 en az bir satır ister (BR-16).',
  UBL_MISSING_ITEM_NAME:
    'Satırda kalem adı yok (BT-153, BR-25). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_UNKNOWN_UNIT:
    'Satırın ölçü birimi UN/ECE Rec 20 listesinde yok (BT-130). Katalog kalemindeki birimi düzeltin; ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_EXEMPTION_REASON_PENDING:
    'Zorunlu ibare bu belgenin dilinde doğrulanmadığı için satırda NÖBETÇİ bir gerekçe duruyor. Belge gönderilemez ve bu bir sunucu arızası değildir.',
  UBL_EXEMPTION_REASON_REQUIRED:
    'Muafiyet / ters yükümlülük satırında gerekçe kodu ya da metni yok (BR-AE-10 / BR-E-10). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_INVALID_VATEX_CODE:
    'Muafiyet gerekçesi kodu VATEX listesinden değil; BT-121 yalnız VATEX kodu taşır. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_VATEX_CATEGORY_MISMATCH:
    'Muafiyet kodu ile KDV kategorisi uyuşmuyor (ör. VATEX-EU-AE yalnız AE ile). Asıl tehlike ret değil SESSİZ KABULDÜR: alıcının muhasebesi işlemi yanlış rejimde kaydeder.',
  UBL_CATEGORY_O_NOT_SENDABLE:
    'Kapsam dışı (O) kategorisi bu belgede modellenmedi ve gönderilemez. Bu bir sunucu arızası değildir.',
  UBL_LEGAL_MENTION_LANGUAGE_MISSING:
    'Belgeye donmuş zorunlu ibarenin, belgenin KENDİ dilindeki metni yok. Susup göndermek zorunlu ibaresi eksik bir e-fatura yaymak olurdu. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_CORRECTED_DOCUMENT_MISSING:
    'Kredi notu neyi düzelttiğini söylemiyor (BT-25); AR n° 1 md. 12 §3 düzeltilen belgeye atıf ister. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_CORRECTED_DOCUMENT_DATE_NOT_FROZEN:
    'Kredi notunda düzeltilen belgenin TARİHİ (BT-26) donmamış. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_DELIVERY_COUNTRY_MISSING:
    'AB içi teslimde malın vardığı ülke (BT-80) belgeye donmamış; muafiyetin dayanağı gösterilemez. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_DELIVERY_DATE_MISSING:
    'Teslim tarihi (BT-72) eksik. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_TOTALS_INCONSISTENT:
    'Belgenin dondurulmuş toplamları EN 16931 BR-CO zincirini tutmuyor. 8 Temmuz 2025 kraliyet kararnamesi yapısal e-faturada yuvarlama toleransını KALDIRDI; belge gönderilemez. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_LINE_ARITHMETIC_INCONSISTENT:
    'Bir satırın dondurulmuş tutarları kendi içinde tutarsız (BR-24). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_VAT_BREAKDOWN_INVALID:
    'KDV kırılımı geçersiz: her (oran, kategori) grubu tam bir kez ve tutarlı olmalı (BR-CO-17). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_BREAKDOWN_GROUP_NOT_IN_LINES:
    'KDV kırılımında satırlarda karşılığı olmayan bir grup var. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_LINE_GROUP_NOT_IN_BREAKDOWN:
    'Satırların bir (oran, kategori) grubu KDV kırılımında yok. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_DOCUMENT_DISCOUNT_UNRESOLVABLE:
    'Belge düzeyindeki indirim bir KDV grubuna bağlanamıyor; hangi orana yazılacağı belirsiz. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_ROUNDING_NOT_REPRESENTABLE:
    'Yuvarlama tutarı UBL’de temsil edilemiyor. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_MISSING_TAX_CURRENCY_AMOUNT:
    'EUR dışı bir belgede EUR karşılığı KDV tutarı (BT-111) donmamış. ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',
  UBL_AMOUNT_MALFORMED:
    'Dondurulmuş bir tutar beklenen biçimde değil. Bu bir veri bozulmasıdır; belge gönderilmemelidir.',
  UBL_RATE_MALFORMED: 'Dondurulmuş bir KDV oranı beklenen biçimde değil (veri bozulması).',
  UBL_QUANTITY_MALFORMED: 'Dondurulmuş bir miktar beklenen biçimde değil (veri bozulması).',
  UBL_DATE_MALFORMED: 'Dondurulmuş bir tarih YYYY-AA-GG biçiminde değil (veri bozulması).',
  UBL_TEXT_NOT_XML_SAFE:
    'Belgedeki bir metin XML’de taşınamayacak bir karakter içeriyor (ör. denetim karakteri). ⚠ Belge DONMUŞTUR: düzeltmenin tek yolu kredi notu + yeni faturadır.',

  // ── Belge PDF'i
  INVOICE_PDF_NOT_ISSUED:
    'Taslağın PDF’i üretilmez: numarası yoktur, KDV kararı ve zorunlu ibaresi henüz donmamıştır. Önce faturayı düzenleyin.',
  INVOICE_PDF_LEGAL_MENTION_MISSING:
    'Belgeye dondurulmuş zorunlu ibare bloğu eksik ya da belgenin dilinde metni yok; PDF üretilemez. İbare uydurulamaz (CJEU C-247/21).',
  INVOICE_PDF_BANK_ACCOUNT_MISSING:
    'Ödeme talep eden belgede banka hesabı ibaresi dondurulmamış; PDF üretilemez (WER md. III.25 §2).',
  INVOICE_PDF_UNPRINTABLE_TEXT:
    'Belgedeki bir metin, fatura fontunda bulunmayan bir karakter taşıyor. Basılsaydı o karakter sessizce hiç görünmezdi — metni düz harflerle yazın.',
  INVOICE_PDF_TOTALS_INCONSISTENT:
    'Belgenin KDV kırılımı ile toplamları tutmuyor; PDF üretilmedi. Bu bir veri arızasıdır, bildirin.',
  INVOICE_PDF_FONT_UNAVAILABLE:
    'Sunucuda fatura fontları bulunamadı — dağıtım eksik. Bu bir sunucu arızasıdır, faturada düzeltilecek bir şey yoktur.',
  INVOICE_PDF_RENDER_FAILED: 'PDF üretimi beklenmeyen bir hatayla durdu. İz numarasıyla bildirin.',
  LEGAL_MENTION_UNAVAILABLE:
    'Bu işlem türü için zorunlu ibarenin BELGENİN DİLİNDEKİ metni kaynaktan doğrulanmadı; belge düzenlenemez. İbare uydurulamaz (CJEU C-247/21).',

  // ── E-fatura (Peppol) taşıması
  //
  // ⚠ Metinler "belge iletildi mi" sorusuna göre yazıldı. En pahalı yanlış
  // anlama, hiç iletilmemiş bir belgeyi iletilmiş sanmaktır: yükümlülük
  // `einvoiceRequired = true AND einvoiceDocumentId IS NULL` sorgusuyla takip
  // edilir ve mühür yalnız GERÇEK bir başarıda yazılır.
  EINVOICE_MODE_OFF:
    'Peppol modu KAPALI; otomatik gönderim yapılmadı ve ağa hiç çıkılmadı. Baytları hazırlayın, XML’i indirin, sağlayıcı portalına yükleyin ve belgeyi "elle gönderildi" olarak işaretleyin.',
  EINVOICE_INVOICE_NOT_ISSUED:
    'Taslak gönderilemez: belgenin numarası yok. Önce faturayı düzenleyin.',
  EINVOICE_INVOICE_CANCELLED: 'İptal edilmiş belge gönderilmez.',
  EINVOICE_DOCUMENT_TYPE_UNSUPPORTED:
    'Proforma e-fatura olarak gönderilemez: mali bir belge değildir ve Peppol’de karşılığı yoktur.',
  EINVOICE_DOCUMENT_NOT_PREPARED:
    'Bu fatura için e-fatura baytları henüz hazırlanmadı. Önce "Hazırla" adımını çalıştırın.',
  EINVOICE_DOCUMENT_NOT_FOUND: 'Taşıma satırı bulunamadı.',
  EINVOICE_ALREADY_PREPARED:
    'Bu fatura için bu ağda zaten aktif bir taşıma satırı var; ikinci bir satır açılmaz.',
  EINVOICE_ALREADY_SENT:
    'Bu fatura zaten iletildi; ikinci bir gönderim YAPILMAZ. İkinci iletim, alıcının sisteminde ikinci bir borç kaydı doğurur.',
  EINVOICE_ALREADY_DELIVERED:
    'Bu belge zaten iletildi. Elle rejimde indirmek teslimatın kendisidir: ikinci bir yükleme alıcıda ikinci bir borç kaydına yol açabilir.',
  EINVOICE_SEND_IN_PROGRESS:
    'Bir gönderim uçuşta. ⚠ Kör yeniden deneme yapılmaz: sağlayıcı belgeyi almış olabilir ve ikinci deneme alıcıda ikinci bir borç kaydı doğurur. Sonucu bekleyin.',
  EINVOICE_LOCAL_VALIDATION_FAILED:
    'Yerel doğrulayıcı belgeyi durdurdu; ağa hiç çıkılmadı. İhlal edilen kural kodları aşağıda — sağlayıcının ret mesajındaki kodlarla aynı dildedir.',
  EINVOICE_REJECTED_DOCUMENT:
    'Erişim noktası belgeyi REDDETTİ. Sebep taşıma satırındaki ret metnindedir; düzeltilene kadar yeniden gönderim aynı sonucu verir.',
  EINVOICE_RECIPIENT_NOT_ON_NETWORK:
    'Alıcı Peppol ağında bulunamadı. Müşteriyle iletişime geçin; ağa kaydolduğunda AYNI baytlarla yeniden gönderilebilir. Belge o zamana kadar bekleyenler listesinde kalır.',
  EINVOICE_PROVIDER_UNAVAILABLE:
    'Erişim noktası geçici olarak cevap vermedi; belge İLETİLMEDİ. Sağlayıcının ret metni taşıma satırında saklandı — ekrandaki "Sağlayıcı yanıtı" alanına bakın.',
  EINVOICE_PROVIDER_UNAUTHORIZED:
    'Sağlayıcı kimliğimizi kabul etmedi (API anahtarı). Bu bir taşıma arızası DEĞİLDİR ve kendiliğinden düzelmez: Ayarlar → Peppol bölümünden anahtarı yenileyin.',
  EINVOICE_PROVIDER_NOT_CONFIGURED:
    'Erişim noktası ayarları eksik. Ayarlar → Peppol bölümünde adres ve API anahtarını doldurun.',
  EINVOICE_PROVIDER_MESSAGE_ID_CONFLICT:
    'Sağlayıcının verdiği iletim kimliği başka bir belgede kayıtlı. Bu bir veri arızasıdır, iz numarasıyla bildirin.',
  EINVOICE_PROVIDER_MESSAGE_ID_TOO_LONG:
    'Gönderim yapıldı ama sağlayıcının iletim kimliği kaydedilemedi (kolon dar). Teslim bildirimi bu belgeyle eşleşemeyebilir; iz numarasıyla bildirin.',
  EINVOICE_SEAL_FAILED:
    'Belge iletildi ama faturanın e-fatura mührü yazılamadı. Fatura, iletilmiş olduğu hâlde "bekliyor" görünebilir; iz numarasıyla bildirin.',
  EINVOICE_INVALID_STATE:
    'Belgenin durumu bu işleme uygun değil (arada başka bir yerde değişmiş olabilir). Sayfayı tazeleyip yeniden bakın.',
  EINVOICE_DOCUMENT_IMMUTABLE:
    'Taşıma satırının dondurulmuş bir alanı değiştirilmek istendi; veritabanı tetikleyicisi reddetti. Bu bir yazılım arızasıdır, iz numarasıyla bildirin.',
  EINVOICE_EVENT_APPEND_ONLY:
    'Taşıma olayları salt-ekleme kaydıdır; değiştirme/silme reddedildi. İz numarasıyla bildirin.',
  EINVOICE_ARCHIVE_CORRUPT:
    'Arşivdeki baytlar kayıtlı özetle TUTMUYOR; dosya bozulmuş ya da değiştirilmiş olabilir. Gönderim yapılmadı — yedekten geri yükleme gerekir.',
  EINVOICE_ARCHIVE_MISSING:
    'Arşiv dosyası bulunamadı. Gönderilen baytlar yeniden ÜRETİLMEZ (üretilenler farklı olurdu) — yedekten geri yükleyin.',
  EINVOICE_ARCHIVE_UNAVAILABLE:
    'Arşive yazılamadı ya da arşivden okunamadı. Bu bir sunucu arızasıdır; belgede düzeltilecek bir şey yoktur.',
  // ── Gelen kutusuna elle UBL yükleme (Peppol dışı yol)
  INCOMING_UPLOAD_EMPTY: 'Dosya boş görünüyor. Tedarikçinin gönderdiği XML dosyasını seçin.',
  INCOMING_UPLOAD_NOT_UBL:
    'Bu dosya okunabilir bir e-fatura (UBL) değil. Tedarikçinin e-postasındaki PDF değil, XML ekini yükleyin — PDF bir alış faturasına dönüştürülemez, onu belge eki olarak Alışlar ekranından ekleyebilirsiniz.',
  INCOMING_UPLOAD_FAILED:
    'Dosya arşivlendi ama kaydı yazılamadı. Bu bir sunucu arızasıdır; yeniden deneyin.',

  // ── E-postayla fatura gönderimi (Peppol dışı kanal)
  EINVOICE_EMAIL_NO_CONSENT:
    'Bu müşteri için e-posta ile e-fatura anlaşması kayıtlı değil. Yurtiçi B2B’de yapılandırılmış e-fatura zorunlu ve standart kanal Peppol’dür; e-postayla göndermek ancak iki taraf anlaşırsa mümkündür. Müşteri kartındaki “E-posta ile e-fatura” bölümünü doldurun.',
  EINVOICE_EMAIL_NOT_CONFIGURED:
    'Giden e-posta yapılandırılmamış: Resend API anahtarı (Ayarlar → Bildirim) ya da sunucudaki gönderici adresi (MAIL_FROM) eksik.',
  EINVOICE_EMAIL_TEST_NETWORK:
    'Peppol modu TEST: bu modda hazırlanan belge gerçek müşteriye gönderilmez. Ayarlardan modu OFF ya da LIVE yapın.',
  EINVOICE_EMAIL_PROVIDER_ERROR:
    'E-posta sağlayıcısı gönderimi reddetti ya da yanıt vermedi. Belge GÖNDERİLMEDİ ve “hazırlandı” durumunda kaldı; düzeltip yeniden deneyin.',
  CONTACT_EINVOICE_EMAIL_CONSENT_INCOMPLETE:
    'E-posta ile e-fatura anlaşması YARIM: adres, onay tarihi ve onayın nerede verildiği birlikte girilir. Yarım bir kayıt denetimde hiçbir şeyin kanıtı değildir.',
  CONTACT_EINVOICE_EMAIL_CONSENT_INVALID_DATE:
    'Onay tarihi geçerli bir takvim günü olmalı (YYYY-AA-GG).',
  CONTACT_EINVOICE_EMAIL_CONSENT_FUTURE:
    'Onay tarihi gelecekte olamaz: e-posta kanalının dayanağı o günden önce yoktur.',
  EINVOICE_ARCHIVE_NOT_BACKED_UP:
    'E-fatura arşiv klasörü yedek düzeninin DIŞINDA; hiçbir belge arşivlenmedi. Yedeklenmeyen bir arşiv, saklama yükümlülüğünü karşılamaz — sunucu yapılandırmasını düzeltin (EINVOICE_ARCHIVE_DIR).',

  CREDIT_NOTE_ORIGINAL_NOT_INVOICE:
    'Kredi notu yalnız bir FATURAYA karşı yazılır. Proformanın ya da kredi notunun kredi notu diye bir belge yoktur.',
  CREDIT_NOTE_ORIGINAL_NOT_ISSUED:
    'Yalnız DÜZENLENMİŞ bir fatura düzeltilebilir. Taslak "düzeltilmez", silinir.',
  CREDIT_NOTE_EXCEEDS_ORIGINAL:
    'Bu kredi notu, aynı faturaya daha önce düzenlenmiş kredi notlarıyla birlikte orijinal tutarı AŞIYOR — orijinalden fazla matrah ve KDV geri alınamaz. Satırları ya da adetleri kalan tutara indirin.',
  CREDIT_NOTE_LINE_UNKNOWN: 'Seçilen satır numarası orijinal faturada yok.',
  VAT_SETTLEMENT_DOCUMENTS_UNPOSTED:
    'Bu dönemin deftere girmemiş satış ya da alış belgeleri var. Mahsup beyanın kutularından kurulur; belgeler hesaplara yazılmadan mahsup yazılırsa KDV hesapları ters bakiyeye düşer. Önce Defter ekranındaki “deftere girmemiş belgeleri” kaydedin.',
  VAT_SETTLEMENT_REPLACED_POSTED:
    'Bu düzeltici beyanın düzelttiği beyanın mahsubu hâlâ defterde. İkisi birden dursa dönem iki kez kapanırdı: önce eski mahsup fişini ters kayıtla kapatın, sonra bu beyanın mahsubunu kaydedin.',
  POSTING_VAT_GRID_UNMAPPED:
    'Beyanda mahsup hesabı tanımlanmamış bir vergi kutusu dolu (ör. 57, ithalat KDV’si). Hangi hesaba yazılacağı uydurulmaz; bu dönemin mahsubunu Defter ekranında elle girin.',
  VAT_PAYMENT_REMOVE_POSTED:
    'Bu KDV ödemesi deftere kaydedilmiş; silinirse fişi defterde kalır ve banka eksilmiş ama ödeme yokmuş görünür. Önce Defter → Yevmiye ekranında ödeme fişini ters kayıtla kapatın, sonra silin.',
  VAT_SETTLEMENT_NOTHING_TO_POST:
    'Bu beyanda KDV hareketi yok (nihil ya da yalnız sıfır oranlı işlemler); mahsup fişi gerekmez ve yazılmaz.',
  CREDIT_NOTE_WITHOUT_ORIGINAL:
    'Kredi notu, düzelttiği faturaya atıflı olmak zorunda (AR n° 1 md. 12 §3).',
  CREDIT_NOTE_UNMAPPED_ORIGINAL_GRID:
    'Orijinal faturanın kutularından biri kredi notu kutusuna eşlenemiyor.',

  BRUSSELS_TIMEZONE_UNAVAILABLE:
    'Sunucu Brüksel saat dilimini çözemedi; tarih hesapları güvenilir değil. Sunucu yöneticisine bildirin.',

  // ── Uyum takvimi — elle girilen son günler
  COMPLIANCE_OVERRIDE_KIND_NOT_IN_CALENDAR:
    'Bu yükümlülük takvimde gösterilmiyor; ona girilen bir tarih hiçbir ekranda görünmezdi.',
  COMPLIANCE_OVERRIDE_PERIOD_INVALID:
    'Dönem bu yükümlülüğe uymuyor: KDV beyanı ve AB içi liste için YYYYQn ya da YYYYMnn, yıllık yükümlülükler için YYYY girin.',
  COMPLIANCE_OVERRIDE_INVALID_DATE: 'Son gün geçerli bir takvim günü olmalı (YYYY-AA-GG).',
  COMPLIANCE_OVERRIDE_REASON_INVALID:
    'Gerekçe zorunlu (en fazla 500 karakter): bu tarihin nereden geldiği yazılımda durmalı.',
  COMPLIANCE_OVERRIDE_SOURCE_INVALID:
    'Kaynak bağlantısı https:// ile başlayan geçerli bir adres olmalı.',
  COMPLIANCE_OVERRIDE_BEFORE_PERIOD_END: 'Son gün, dönem bitmeden önce olamaz.',
  COMPLIANCE_OVERRIDE_EXTENSION_NEEDS_SOURCE:
    'Bu tarih yazılımın hesapladığı son günden SONRA. Sizi geç bırakabilecek tek yön bu olduğu için resmî kaynağın bağlantısı zorunlu (örneğin FOD’un uzatma duyurusu).',
  COMPLIANCE_OVERRIDE_NOT_FOUND: 'Bu yükümlülük ve dönem için elle girilmiş bir tarih yok.',
  COMPLIANCE_REMINDERS_BUSY:
    'Hatırlatma koşumu şu anda zaten çalışıyor. Birkaç saniye sonra günlüğü yenileyin; gönderilmiş bir hatırlatma yeniden gitmez.',
  SUBSCRIPTION_GENERATION_BUSY:
    'Abonelik faturalarının otomatik üretimi şu anda zaten çalışıyor (günlük koşumla çakıştı olabilir). Birkaç saniye sonra tekrar deneyin.',

  // ── Yapay zekâ asistanı
  ASSISTANT_DISABLED: 'Yapay zekâ asistanı kapalı. Ayarlar → Asistan bölümünden açabilirsiniz.',
  ASSISTANT_NO_API_KEY:
    'Asistan için bir Anthropic API anahtarı girilmemiş. Ayarlar → Asistan bölümünden ekleyin.',
  ASSISTANT_DAILY_CAP_REACHED:
    'Bugünkü sohbet turu tavanına ulaşıldı. Yarın Brüksel gününde sıfırlanır; tavanı Ayarlar → Asistan bölümünden değiştirebilirsiniz.',
  ASSISTANT_TEMPORARILY_UNAVAILABLE:
    'Asistan şu anda yanıt veremiyor (art arda hatalar sonrası birkaç dakika beklemede). Biraz sonra tekrar deneyin.',
  ASSISTANT_PROVIDER_ERROR:
    'Asistan sağlayıcısına ulaşılamadı ya da beklenmeyen bir yanıt geldi. Tekrar deneyin; sürerse iz numarasını paylaşın.',
  ASSISTANT_CONVERSATION_NOT_FOUND: 'Bu sohbet bulunamadı — silinmiş olabilir.',

  // ── Altyapı
  RATE_LIMITED: 'Çok fazla deneme yapıldı. Lütfen biraz bekleyip tekrar deneyin.',
  NOT_FOUND: 'Kayıt bulunamadı.',
  CONFLICT: 'Bu işlem mevcut bir kayıtla çakışıyor.',
  INTERNAL_ERROR: 'Sunucuda beklenmeyen bir hata oluştu.',
  INVALID_RESPONSE: 'Sunucudan beklenmeyen bir yanıt geldi.',
  NETWORK_ERROR: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.',
};

const FALLBACK = 'Beklenmeyen bir hata oluştu.';

interface ErrorLike {
  code?: unknown;
  traceId?: unknown;
}

function readCode(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const code = (err as ErrorLike).code;
  return typeof code === 'string' ? code : null;
}

/** Operatöre gösterilecek cümle. Her zaman Türkçe ve her zaman doludur. */
export function errorMessage(err: unknown): string {
  const code = readCode(err);
  if (!code) return FALLBACK;
  return MESSAGES[code] ?? FALLBACK;
}

/**
 * Elde hata NESNESİ yokken — panelin sunucudan ÖNCE saydığı bir iş kuralı
 * gibi — aynı cümleyi almanın yolu.
 *
 * Var oluş sebebi tek: panel bir kuralı erken saydığında operatör, sunucunun
 * aynı kodda göstereceği metnin AYNISINI görmeli. İki farklı cümle, tek bir
 * kuralı iki ayrı hata sanmaya yol açar.
 */
export function messageForCode(code: string): string | null {
  return MESSAGES[code] ?? null;
}

/**
 * 500'lerde operatörün destekle paylaşabileceği tek şey traceId'dir; sunucu
 * iç detayı bilerek sızdırmaz. Bu yüzden mesajın yanında gösterilir.
 */
export function errorDetail(err: unknown): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const traceId = (err as ErrorLike).traceId;
  return typeof traceId === 'string' ? `İz numarası: ${traceId}` : null;
}

/**
 * Hangi form alanları geçersiz? Sunucu `fields` dizisini hem class-validator
 * hatalarında hem de iş kuralı hatalarında doldurur (örn. IBAN_MUST_BE_BELGIAN
 * → ['company_iban']) — form alan altına kırmızı yazıyı buradan alır.
 */
export function errorFields(err: unknown): Set<string> {
  if (typeof err !== 'object' || err === null) return new Set();
  const fields = (err as { fields?: unknown }).fields;
  if (!Array.isArray(fields)) return new Set();
  return new Set(fields.filter((f): f is string => typeof f === 'string'));
}

/** Belirli bir koda mı bakıyoruz? Çağrı noktalarında `err.code === '...'` yerine. */
export function hasCode(err: unknown, ...codes: string[]): boolean {
  const code = readCode(err);
  return code !== null && codes.includes(code);
}
